<template>
  <div class="sff-2023-interactive-viz-1">
    <div id="g-UOB-2023-box" class="ai2html">
      <!-- Artboard: 730px -->
      <div
        id="g-UOB-2023-730px"
        class="g-artboard"
        style="width: 729px; height: 895px; overflow: hidden"
        data-aspect-ratio="0.816"
        data-min-width="729"
      >
        <!-- Generator: Adobe Illustrator 28.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
        <svg
          class="g-UOB-730px-enabler-datanalytics-img g-aiImg"
          version="1.2"
          baseProfile="tiny"
          id="g-UOB-2023-730px-enabler-datanalytics-img"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 730 895"
          overflow="visible"
          xml:space="preserve"
        >
          <g>
            <g class="line line-e-analytics" data-name="line line-e-analytics">
              <path
                id="line:svg"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                d="
      M227.765,245.668h48.858v507.775c0,5.469,4.477,9.903,10,9.903h44.389"
              />

              <polyline
                id="line:svg"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                points="
      227.765,245.668 276.623,245.668 276.623,634.489 462.41,634.489 		"
              />

              <polyline
                id="line:svg"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                points="
      227.765,245.668 276.623,245.668 276.623,505.632 331.352,505.632 		"
              />

              <polyline
                id="line:svg"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                points="
      227.765,245.668 276.623,245.668 276.623,377.044 461.145,377.044 		"
              />

              <polyline
                id="line:svg"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                points="
      227.765,245.668 276.623,245.668 276.623,245.668 331.151,245.668 		"
              />
            </g>
            <g class="circle circle-e-analytics" data-name="circle circle-e-analytics">
              <circle id="circle:svg" data-name="circle:svg" fill="#3EB770" cx="331.027" cy="245.668" r="2.5" />
              <circle id="circle:svg" data-name="circle:svg" fill="#3EB770" cx="227.765" cy="245.668" r="2.5" />
              <circle id="circle:svg" data-name="circle:svg" fill="#3EB770" cx="461.145" cy="377.044" r="2.5" />
              <circle id="circle:svg" data-name="circle:svg" fill="#3EB770" cx="331.013" cy="505.632" r="2.5" />
              <circle id="circle:svg" data-name="circle:svg" fill="#3EB770" cx="462.41" cy="634.489" r="2.5" />
              <circle id="circle:svg" data-name="circle:svg" fill="#3EB770" cx="331.013" cy="763.345" r="2.5" />
            </g>
          </g>
        </svg>

        <!-- Generator: Adobe Illustrator 28.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
        <svg
          class="g-UOB-730px-enabler-datacollection-img g-aiImg"
          version="1.2"
          baseProfile="tiny"
          id="g-UOB-2023-730px-enabler-datacollection-img"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 730 895"
          overflow="visible"
          xml:space="preserve"
        >
          <g>
            <g class="line line-e-collection" data-name="line line-e-collection">
              <path
                id="line:svg"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                d="
        M227.765,313.622h48.858v310.946c0,5.479,4.477,9.921,10,9.921H462.41"
              />

              <polyline
                id="line:svg"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                points="
        227.765,313.622 276.623,313.622 276.623,505.632 331.352,505.632 		"
              />

              <polyline
                id="line:svg-8"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                points="
        227.765,313.622 276.623,313.622 276.623,377.044 461.145,377.044 		"
              />

              <path
                id="line:svg-9"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                d="
        M227.765,313.622h48.858c0,0,0.207-27.357,0.277-57.982c0.013-5.514,4.486-9.972,10-9.972h44.127"
              />
            </g>
            <g class="circle circle-e-collection" data-name="circle circle-e-collection">
              <circle id="circle:svg" data-name="circle:svg" fill="#3EB770" cx="331.027" cy="245.668" r="2.5" />
              <circle id="circle:svg" data-name="circle:svg" fill="#3EB770" cx="461.145" cy="377.044" r="2.5" />
              <circle id="circle:svg-8" data-name="circle:svg" fill="#3EB770" cx="331.352" cy="505.632" r="2.5" />
              <circle id="circle:svg-9" data-name="circle:svg" fill="#3EB770" cx="462.41" cy="634.489" r="2.5" />
              <circle id="circle:svg0" data-name="circle:svg" fill="#3EB770" cx="227.765" cy="313.622" r="2.5" />
            </g>
          </g>
        </svg>

        <!-- Generator: Adobe Illustrator 28.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
        <svg
          class="g-UOB-730px-enabler-carbonservices-img g-aiImg"
          version="1.2"
          baseProfile="tiny"
          id="g-UOB-2023-730px-enabler-carbonservices-img"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 730 895"
          overflow="visible"
          xml:space="preserve"
        >
          <g>
            <g class="line line-e-carbon" data-name="line line-e-carbon">
              <path
                id="line:svg0"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                d="
        M227.765,377.044h48.858v247.543c0,5.469,4.477,9.902,10,9.902H462.41"
              />

              <polyline
                id="line:svg1"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                points="
        227.765,377.044 276.623,377.044 276.623,505.632 331.352,505.632 		"
              />

              <line
                id="line:svg2"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                x1="227.765"
                y1="377.044"
                x2="461.145"
                y2="377.044"
              />
            </g>
            <g class="circle circle-e-carbon" data-name="circle circle-e-carbon">
              <circle id="circle:svg1" data-name="circle:svg" fill="#3EB770" cx="227.765" cy="377.044" r="2.5" />
              <circle id="circle:svg2" data-name="circle:svg" fill="#3EB770" cx="461.145" cy="377.044" r="2.5" />
              <circle id="circle:svg3" data-name="circle:svg" fill="#3EB770" cx="331.352" cy="505.632" r="2.5" />
              <circle id="circle:svg4" data-name="circle:svg" fill="#3EB770" cx="462.41" cy="634.489" r="2.5" />
            </g>
          </g>
        </svg>

        <!-- Generator: Adobe Illustrator 28.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
        <svg
          class="g-UOB-730px-enabler-reporting-img g-aiImg"
          version="1.2"
          baseProfile="tiny"
          id="g-UOB-2023-730px-enabler-reporting-img"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 730 895"
          overflow="visible"
          xml:space="preserve"
        >
          <g>
            <g class="line line-e-reporting" data-name="line line-e-reporting">
              <path
                id="line:svg3"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                d="
        M227.765,444.428h38.858c5.523,0,10,4.424,10,9.881v299.155c0,5.457,4.477,9.881,10,9.881h44.729"
              />
            </g>
            <g class="circle circle-e-reporting" data-name="circle circle-e-reporting">
              <circle id="circle:svg5" data-name="circle:svg" fill="#3EB770" cx="227.765" cy="444.428" r="2.5" />
              <circle id="circle:svg6" data-name="circle:svg" fill="#3EB770" cx="331.352" cy="763.345" r="2.5" />
            </g>
          </g>
        </svg>

        <!-- Generator: Adobe Illustrator 28.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
        <svg
          class="g-UOB-730px-enabler-infrastructure-img g-aiImg"
          version="1.2"
          baseProfile="tiny"
          id="g-UOB-2023-730px-enabler-infrastructure-img"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 730 895"
          overflow="visible"
          xml:space="preserve"
        >
          <g>
            <g class="line line-e-infrastructure" data-name="line line-e-infrastructure">
              <path
                id="line:svg4"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                d="
        M227.765,509.893h38.858c5.523,0,10,4.389,10,9.803v233.845c0,5.414,4.477,9.803,10,9.803h44.39"
              />

              <path
                id="line:svg5"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                d="
        M227.765,509.893h38.858c5.523,0,10,4.388,10,9.8v114.796H462.41"
              />
            </g>
            <g class="circle circle-e-infrastructure" data-name="circle circle-e-infrastructure">
              <circle id="circle:svg7" data-name="circle:svg" fill="#3EB770" cx="227.765" cy="509.893" r="2.5" />
              <circle id="circle:svg8" data-name="circle:svg" fill="#3EB770" cx="462.41" cy="634.489" r="2.5" />
              <circle id="circle:svg9" data-name="circle:svg" fill="#3EB770" cx="331.013" cy="763.345" r="2.5" />
            </g>
          </g>
        </svg>

        <!-- Generator: Adobe Illustrator 28.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
        <svg
          class="g-UOB-730px-enabler-regtech-img g-aiImg"
          version="1.2"
          baseProfile="tiny"
          id="g-UOB-2023-730px-enabler-regtech-img"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 730 895"
          overflow="visible"
          xml:space="preserve"
        >
          <g>
            <g class="line line-e-regtech" data-name="line line-e-regtech">
              <path
                id="line:svg6"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                d="
        M227.765,575.892h38.858c5.523,0,10,4.395,10,9.816v167.436c0,5.421,4.477,9.816,10,9.816h44.729"
              />
            </g>
            <g class="circle circle-e-regtech" data-name="circle circle-e-regtech">
              <circle id="circle:svg0" data-name="circle:svg" fill="#3EB770" cx="227.765" cy="575.893" r="2.5" />
              <circle id="circle:svg9" data-name="circle:svg" fill="#3EB770" cx="331.013" cy="763.345" r="2.5" />
            </g>
          </g>
        </svg>

        <!-- Generator: Adobe Illustrator 28.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
        <svg
          class="g-UOB-730px-stage-assess-img g-aiImg"
          version="1.2"
          baseProfile="tiny"
          id="g-UOB-2023-730px-stage-assess-img"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 730 895"
          overflow="visible"
          xml:space="preserve"
        >
          <g>
            <g class="line line-s-assess" data-name="line line-s-assess">
              <line
                id="line:svg7"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                x1="227.765"
                y1="245.668"
                x2="331.28"
                y2="245.668"
              />

              <path
                id="line:svg8"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
        M331.28,245.668h-54.656v57.954c0,5.523-4.477,10-10,10h-38.858"
              />
            </g>
            <g class="circle circle-s-assess" data-name="circle circle-s-assess">
              <circle id="circle:svg1" data-name="circle:svg" fill="#8095FF" cx="227.765" cy="245.668" r="2.5" />
              <circle id="circle:svg2" data-name="circle:svg" fill="#8095FF" cx="331.28" cy="245.668" r="2.5" />
              <circle id="circle:svg3" data-name="circle:svg" fill="#8095FF" cx="227.765" cy="313.622" r="2.5" />
            </g>
          </g>
        </svg>

        <!-- Generator: Adobe Illustrator 28.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
        <svg
          class="g-UOB-730px-stage-strategise-img g-aiImg"
          version="1.2"
          baseProfile="tiny"
          id="g-UOB-2023-730px-stage-strategise-img"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 730 895"
          overflow="visible"
          xml:space="preserve"
        >
          <g>
            <g class="line line-s-strategise" data-name="line line-s-strategise">
              <polyline
                id="line:svg9"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                points="
        461.47,377.044 276.623,377.044 276.623,313.622 227.765,313.622 		"
              />

              <path
                id="line:svg0"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
        M461.47,377.044H276.623V255.668c0-5.523-4.477-10-10-10h-38.858"
              />

              <line
                id="line:svg1"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                x1="461.47"
                y1="377.044"
                x2="227.765"
                y2="377.044"
              />
            </g>
            <g class="circle circle-s-strategise" data-name="circle circle-s-strategise">
              <circle id="circle:svg4" data-name="circle:svg" fill="#8095FF" cx="227.765" cy="245.668" r="2.5" />
              <circle id="circle:svg5" data-name="circle:svg" fill="#8095FF" cx="227.765" cy="313.622" r="2.5" />
              <circle id="circle:svg6" data-name="circle:svg" fill="#8095FF" cx="227.765" cy="377.044" r="2.5" />
              <circle id="circle:svg7" data-name="circle:svg" fill="#8095FF" cx="461.145" cy="377.044" r="2.5" />
            </g>
          </g>
        </svg>

        <!-- Generator: Adobe Illustrator 28.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
        <svg
          class="g-UOB-730px-stage-develop-img g-aiImg"
          version="1.2"
          baseProfile="tiny"
          id="g-UOB-2023-730px-stage-develop-img"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 730 895"
          overflow="visible"
          xml:space="preserve"
        >
          <g>
            <g class="line line-s-develop" data-name="line line-s-develop">
              <path
                id="line:svg2"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
        M331.013,505.632h-44.389c-5.523,0-10-4.477-10-10V313.622h-48.858"
              />

              <path
                id="line:svg3"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
        M331.013,505.632h-44.389c-5.523,0-10-4.477-10-10V255.668c0-5.523-4.477-10-10-10h-38.858"
              />

              <path
                id="line:svg4"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
        M331.013,505.632h-44.389c-5.523,0-10-4.477-10-10v-118.59h-48.858"
              />
            </g>
            <g class="circle circle-s-develop" data-name="circle circle-s-develop">
              <circle id="circle:svg8" data-name="circle:svg" fill="#8095FF" cx="227.765" cy="245.897" r="2.5" />
              <circle id="circle:svg9" data-name="circle:svg" fill="#8095FF" cx="227.765" cy="313.622" r="2.5" />
              <circle id="circle:svg0" data-name="circle:svg" fill="#8095FF" cx="227.765" cy="377.043" r="2.5" />
              <circle id="circle:svg1" data-name="circle:svg" fill="#8095FF" cx="331.013" cy="505.632" r="2.5" />
            </g>
          </g>
        </svg>

        <!-- Generator: Adobe Illustrator 28.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
        <svg
          class="g-UOB-730px-stage-operationalise-img g-aiImg"
          version="1.2"
          baseProfile="tiny"
          id="g-UOB-2023-730px-stage-operationalise-img"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 730 895"
          overflow="visible"
          xml:space="preserve"
        >
          <g>
            <g class="line line-s-operationalise" data-name="line line-s-operationalise">
              <path
                id="line:svg5"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
        M462.411,634.489H286.623c-5.523,0-10-4.448-10-9.935V255.603c0-5.487-4.477-9.935-10-9.935h-38.858"
              />

              <path
                id="line:svg6"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
        M462.411,634.489H286.623c-5.523,0-10-4.442-10-9.921V313.622h-48.858"
              />

              <path
                id="line:svg7"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
        M462.411,634.489H286.623c-5.523,0-10-4.433-10-9.902V377.043h-48.858"
              />

              <path
                id="line:svg8"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
        M462.411,634.489H286.623c-5.523,0-10-4.388-10-9.8V509.892h-48.858"
              />
            </g>
            <g class="circle circle-s-operationalise" data-name="circle circle-s-operationalise">
              <circle id="circle:svg2" data-name="circle:svg" fill="#8095FF" cx="227.765" cy="245.668" r="2.5" />
              <circle id="circle:svg3" data-name="circle:svg" fill="#8095FF" cx="227.765" cy="313.622" r="2.5" />
              <circle id="circle:svg4" data-name="circle:svg" fill="#8095FF" cx="227.765" cy="377.044" r="2.5" />
              <circle id="circle:svg5" data-name="circle:svg" fill="#8095FF" cx="227.765" cy="509.893" r="2.5" />
              <circle id="circle:svg6" data-name="circle:svg" fill="#8095FF" cx="462.469" cy="634.489" r="2.5" />
            </g>
          </g>
        </svg>

        <!-- Generator: Adobe Illustrator 28.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
        <svg
          class="g-UOB-730px-stage-socialise-img g-aiImg"
          version="1.2"
          baseProfile="tiny"
          id="g-UOB-2023-730px-stage-socialise-img"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 730 895"
          overflow="visible"
          xml:space="preserve"
        >
          <g>
            <g class="line line-s-socialise" data-name="line line-s-socialise">
              <path
                id="line:svg9"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
        M331.013,763.345h-44.389c-5.523,0-10-4.407-10-9.843V444.428h-48.858"
              />

              <path
                id="line:svg0"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
        M331.013,763.345h-44.389c-5.523,0-10-4.45-10-9.94V255.608c0-5.49-4.477-9.94-10-9.94h-38.858"
              />

              <path
                id="line:svg1"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
        M331.013,763.345h-44.389c-5.523,0-10-4.389-10-9.803V509.893h-48.858"
              />

              <path
                id="line:svg2"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
        M331.013,763.345h-44.389c-5.523,0-10-4.359-10-9.736V575.892h-48.858"
              />
            </g>
            <g class="circle circle-s-socialise" data-name="circle circle-s-socialise">
              <circle id="circle:svg7" data-name="circle:svg" fill="#8095FF" cx="227.765" cy="245.649" r="2.5" />
              <circle id="circle:svg8" data-name="circle:svg" fill="#8095FF" cx="227.765" cy="444.428" r="2.5" />
              <circle id="circle:svg9" data-name="circle:svg" fill="#8095FF" cx="227.765" cy="509.468" r="2.5" />
              <circle id="circle:svg0" data-name="circle:svg" fill="#8095FF" cx="227.765" cy="575.892" r="2.5" />
              <circle id="circle:svg1" data-name="circle:svg" fill="#8095FF" cx="331.013" cy="763.345" r="2.5" />
            </g>
          </g>
        </svg>

        <div class="html-el">
          <div class="viz-1-header mb-30" v-if="content">
            <h3 class="text-body--large mb-15 font-weight-bold" style="margin-bottom: 15px">
              {{ copy.header }}
            </h3>
            <p class="text-body legend"><span class="dia-icon" style="margin-right: 12px" />{{ copy.diamond }}</p>
            <p class="text-body legend"><span class="rect-icon" style="margin-right: 12px" />{{ copy.rectangle }}</p>
          </div>

          <div style="display: flex">
            <div class="viz-1-enabler-buttons">
              <p class="text-small mb-15" style="margin-bottom: 15px;">Types of green FinTech enablers and where they can help</p>

              <div
                v-for="enabler in enablerData"
                :key="enabler.id"
                type="button"
                button_name="roadmap"
                data-toggle="modal"
                data-target="#viz-1-modal"
                @click="handleEnabler(enabler.id)"
                @mouseenter="handlePathEnabler(enabler.id)"
                @mouseleave="handleReset"
                :class="['enabler-button dtm-button', enabler.id]"
              >
                <p class="text-body font-weight-bold text-center text--primary enabler-label">{{ enabler.label }}</p>
              </div>
            </div>

            <div class="viz-1-stage-diamonds">
              <div
                type="button"
                button_name="roadmap"
                data-toggle="modal"
                data-target="#viz-1-modal"
                @click="handleStage('s-assess')"
                @mouseenter="handlePathStage('s-assess')"
                @mouseleave="handleReset"
                class="stage-button dtm-button s-assess"
              >
                <div class="dia-bg" />

                <div class="dia-content">
                  <viz-1-icon-assess width="23" height="19" :iconColor="iconColor" />

                  <div class="text-center">
                    <p class="text-body font-weight-bold">Assess</p>
                    <p class="text-small">Understand the company&rsquo;s sustainability landscape</p>
                  </div>
                </div>
              </div>

              <div
                type="button"
                button_name="roadmap"
                data-toggle="modal"
                data-target="#viz-1-modal"
                @click="handleStage('s-develop')"
                @mouseenter="handlePathStage('s-develop')"
                @mouseleave="handleReset"
                class="stage-button dtm-button s-develop"
                style="margin-top: 87.5px"
              >
                <div class="dia-bg" />

                <div class="dia-content">
                  <viz-1-icon-develop width="19" height="21" :iconColor="iconColor" />

                  <div class="text-center">
                    <p class="text-body font-weight-bold">Develop</p>
                    <p class="text-small" style="font-size: 14.1px">
                      Map key activities, identify enabling technologies and funding/resources needed
                    </p>
                  </div>
                </div>
              </div>

              <div
                type="button"
                button_name="roadmap"
                data-toggle="modal"
                data-target="#viz-1-modal"
                @click="handleStage('s-socialise')"
                @mouseenter="handlePathStage('s-socialise')"
                @mouseleave="handleReset"
                class="stage-button dtm-button s-socialise"
                style="margin-top: 81.5px"
              >
                <div class="dia-bg" />

                <div class="dia-content">
                  <viz-1-icon-socialise width="23" height="19" :iconColor="iconColor" />

                  <div class="text-center">
                    <p class="text-body font-weight-bold">Socialise</p>
                    <p class="text-small">Engage stakeholders, report on progress and iterate strategies</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="viz-1-stage-diamonds" style="margin-top: 133.5px; margin-left: -44px">
              <div
                type="button"
                button_name="roadmap"
                data-toggle="modal"
                data-target="#viz-1-modal"
                @click="handleStage('s-strategise')"
                @mouseenter="handlePathStage('s-strategise')"
                @mouseleave="handleReset"
                class="stage-button dtm-button s-strategise"
              >
                <div class="dia-bg" />

                <div class="dia-content">
                  <viz-1-icon-strategise width="21" height="21" :iconColor="iconColor" />

                  <div class="text-center">
                    <p class="text-body font-weight-bold">Strategise</p>
                    <p class="text-small">Identify most impactful areas for change, and KPIs for each</p>
                  </div>
                </div>
              </div>

              <div
                type="button"
                button_name="roadmap"
                data-toggle="modal"
                data-target="#viz-1-modal"
                @click="handleStage('s-operationalise')"
                @mouseenter="handlePathStage('s-operationalise')"
                @mouseleave="handleReset"
                class="stage-button dtm-button s-operationalise"
                style="margin-top: 80.5px"
              >
                <div class="dia-bg" />

                <div class="dia-content">
                  <viz-1-icon-operationalise width="15" height="21" :iconColor="iconColor" />

                  <div class="text-center">
                    <p class="text-body font-weight-bold">Operationalise</p>
                    <p class="text-small">
                      Assign responsibilities, implement activities and embed tech solutions to track KPIs
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Artboard: 570px -->
      <div
        id="g-UOB-2023-570px"
        class="g-artboard"
        style="width: 570px; height: 895px; overflow: hidden"
        data-aspect-ratio="0.637"
        data-min-width="570"
        data-max-width="728.99"
      >
        <!-- Generator: Adobe Illustrator 28.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
        <svg
          class="g-UOB-570px-enabler-dataanalytics-md-img g-aiImg"
          version="1.2"
          baseProfile="tiny"
          id="g-UOB-2023-570px-enabler-dataanalytics-md-img"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 570 895"
          overflow="visible"
          xml:space="preserve"
        >
          <g>
            <g class="line line-e-analytics" data-name="line line-e-analytics">
              <polyline
                id="line:svg3"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                points="
        166.068,240.073 194.975,240.073 194.975,367.825 335.268,367.825 		"
              />

              <line
                id="line:svg4"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                x1="166.068"
                y1="240.073"
                x2="208.898"
                y2="240.073"
              />

              <polyline
                id="line:svg5"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                points="
        166.068,240.073 194.975,240.073 194.975,492.484 208.9,492.484 		"
              />

              <polyline
                id="line:svg6"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                points="
        166.068,240.073 194.975,240.073 194.975,617.67 336.381,617.67 		"
              />

              <path
                id="line:svg7"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                d="
        M166.068,240.073h28.907v492.943c0,5.303,4.344,9.601,9.702,9.601h4.237"
              />
            </g>
            <g class="circle circle-e-analytics" data-name="circle circle-e-analytics">
              <circle id="circle:svg2" data-name="circle:svg" fill="#3EB770" cx="166.068" cy="240.073" r="2.494" />

              <circle id="circle:svg3" data-name="circle:svg" fill="#3EB770" cx="208.915" cy="240.073" r="2.494" />

              <circle id="circle:svg4" data-name="circle:svg" fill="#3EB770" cx="335.268" cy="367.825" r="2.494" />
              <circle id="circle:svg5" data-name="circle:svg" fill="#3EB770" cx="208.9" cy="492.484" r="2.494" />

              <circle id="circle:svg6" data-name="circle:svg" fill="#3EB770" cx="336.381" cy="617.599" r="2.494" />

              <circle id="circle:svg7" data-name="circle:svg" fill="#3EB770" cx="208.915" cy="742.617" r="2.494" />
            </g>
          </g>
        </svg>

        <!-- Generator: Adobe Illustrator 28.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
        <svg
          class="g-UOB-570px-enabler-datacollection-md-img g-aiImg"
          version="1.2"
          baseProfile="tiny"
          id="g-UOB-2023-570px-enabler-datacollection-md-img"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 570 895"
          overflow="visible"
          xml:space="preserve"
        >
          <g>
            <g class="line line-e-collection" data-name="line line-e-collection">
              <polyline
                id="line:svg8"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                points="
        166.068,304.397 194.975,304.397 194.975,367.825 335.268,367.825 		"
              />

              <polyline
                id="line:svg9"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                points="
        166.068,304.397 194.975,304.397 194.975,492.484 208.9,492.484 		"
              />

              <path
                id="line:svg0"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                d="
        M166.068,304.397h28.907v303.645c0,5.318,4.344,9.628,9.702,9.628h131.703"
              />

              <path
                id="line:svg1"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                d="
        M166.068,304.397h28.907v-54.621c0-5.358,4.344-9.702,9.702-9.702h4.221"
              />
            </g>
            <g class="circle circle-e-collection" data-name="circle circle-e-collection">
              <circle id="circle:svg8" data-name="circle:svg" fill="#3EB770" cx="165.583" cy="304.397" r="2.494" />

              <circle id="circle:svg9" data-name="circle:svg" fill="#3EB770" cx="208.898" cy="240.073" r="2.494" />

              <circle id="circle:svg0" data-name="circle:svg" fill="#3EB770" cx="335.268" cy="367.825" r="2.494" />
              <circle id="circle:svg1" data-name="circle:svg" fill="#3EB770" cx="208.9" cy="492.582" r="2.494" />

              <circle id="circle:svg2" data-name="circle:svg" fill="#3EB770" cx="336.254" cy="617.67" r="2.494" />
            </g>
          </g>
        </svg>

        <!-- Generator: Adobe Illustrator 28.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
        <svg
          class="g-UOB-570px-enabler-carbonservices-md-img g-aiImg"
          version="1.2"
          baseProfile="tiny"
          id="g-UOB-2023-570px-enabler-carbonservices-md-img"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 570 895"
          overflow="visible"
          xml:space="preserve"
        >
          <g>
            <g class="line line-e-carbon" data-name="line line-e-carbon">
              <polyline
                id="line:svg2"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                points="
        166.068,367.825 195.168,367.825 195.168,492.484 208.9,492.484 		"
              />

              <path
                id="line:svg3"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                d="
        M166.068,367.825h29.099V608.06c0,5.307,4.344,9.61,9.702,9.61h131.511"
              />

              <line
                id="line:svg4"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                x1="166.068"
                y1="367.825"
                x2="335.268"
                y2="367.825"
              />
            </g>
            <g class="circle circle-e-carbon" data-name="circle circle-e-carbon">
              <circle id="circle:svg3" data-name="circle:svg" fill="#3EB770" cx="166.068" cy="368.128" r="2.494" />

              <circle id="circle:svg4" data-name="circle:svg" fill="#3EB770" cx="335.268" cy="367.825" r="2.494" />
              <circle id="circle:svg5" data-name="circle:svg" fill="#3EB770" cx="208.9" cy="492.582" r="2.494" />

              <circle id="circle:svg6" data-name="circle:svg" fill="#3EB770" cx="336.437" cy="617.599" r="2.494" />
            </g>
          </g>
        </svg>

        <!-- Generator: Adobe Illustrator 28.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
        <svg
          class="g-UOB-570px-enabler-reporting-md-img g-aiImg"
          version="1.2"
          baseProfile="tiny"
          id="g-UOB-2023-570px-enabler-reporting-md-img"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 570 895"
          overflow="visible"
          xml:space="preserve"
        >
          <g>
            <g class="line line-e-reporting" data-name="line line-e-reporting">
              <path
                id="line:svg5"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                d="
        M166.068,431.858h19.397c5.358,0,9.702,4.276,9.702,9.551v291.658c0,5.275,4.344,9.551,9.702,9.551h4.029"
              />
            </g>
            <g class="circle circle-e-reporting" data-name="circle circle-e-reporting">
              <circle id="circle:svg7" data-name="circle:svg" fill="#3EB770" cx="208.898" cy="742.617" r="2.494" />

              <circle id="circle:svg8" data-name="circle:svg" fill="#3EB770" cx="165.583" cy="431.858" r="2.494" />
            </g>
          </g>
        </svg>

        <!-- Generator: Adobe Illustrator 28.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
        <svg
          class="g-UOB-570px-enabler-infrastructure-md-img g-aiImg"
          version="1.2"
          baseProfile="tiny"
          id="g-UOB-2023-570px-enabler-infrastructure-md-img"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 570 895"
          overflow="visible"
          xml:space="preserve"
        >
          <g>
            <g class="line line-e-infrastructure" data-name="line line-e-infrastructure">
              <path
                id="line:svg6"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                d="
        M166.068,496.715h19.416c5.358,0,9.702,4.258,9.702,9.511v226.879c0,5.253,4.344,9.511,9.702,9.511h4.01"
              />

              <path
                id="line:svg7"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                d="
        M166.068,496.715h19.416c5.358,0,9.702,4.259,9.702,9.514V617.67H336.61"
              />
            </g>
            <g class="circle circle-e-infrastructure" data-name="circle circle-e-infrastructure">
              <circle id="circle:svg9" data-name="circle:svg" fill="#3EB770" cx="336.437" cy="617.67" r="2.494" />

              <circle id="circle:svg0" data-name="circle:svg" fill="#3EB770" cx="208.898" cy="742.617" r="2.494" />

              <circle id="circle:svg1" data-name="circle:svg" fill="#3EB770" cx="165.583" cy="496.715" r="2.494" />
            </g>
          </g>
        </svg>

        <!-- Generator: Adobe Illustrator 28.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
        <svg
          class="g-UOB-570px-enabler-regtech-md-img g-aiImg"
          version="1.2"
          baseProfile="tiny"
          id="g-UOB-2023-570px-enabler-regtech-md-img"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 570 895"
          overflow="visible"
          xml:space="preserve"
        >
          <g>
            <g class="line line-e-regtech" data-name="line line-e-regtech">
              <path
                id="line:svg8"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                d="
        M166.068,560.748h19.393c5.358,0,9.702,4.259,9.702,9.513v162.844c0,5.254,4.344,9.513,9.702,9.513h4.033"
              />
            </g>
            <g class="circle circle-e-regtech" data-name="circles-regtech">
              <circle id="circle:svg2" data-name="circle:svg" fill="#3EB770" cx="165.583" cy="560.748" r="2.494" />

              <circle id="circle:svg3" data-name="circle:svg" fill="#3EB770" cx="208.898" cy="742.617" r="2.494" />
            </g>
          </g>
        </svg>

        <!-- Generator: Adobe Illustrator 28.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
        <svg
          class="g-UOB-570px-stage-assess-md-img g-aiImg"
          version="1.2"
          baseProfile="tiny"
          id="g-UOB-2023-570px-stage-assess-md-img"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 570 895"
          overflow="visible"
          xml:space="preserve"
        >
          <g>
            <g class="line line-s-assess" data-name="line line-s-assess">
              <path
                id="line:svg9"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
        M166.068,304.397h19.401c5.358,0,9.702-4.344,9.702-9.702v-54.621h13.727"
              />

              <line
                id="line:svg0"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                x1="209.008"
                y1="240.073"
                x2="166.068"
                y2="240.073"
              />
            </g>
            <g class="circle circle-s-assess" data-name="circle circle-s-assess">
              <circle id="circle:svg4" data-name="circle:svg" fill="#8095FF" cx="165.583" cy="240.073" r="2.494" />

              <circle id="circle:svg5" data-name="circle:svg" fill="#8095FF" cx="165.583" cy="304.094" r="2.494" />

              <circle id="circle:svg6" data-name="circle:svg" fill="#8095FF" cx="209.008" cy="240.073" r="2.494" />
            </g>
          </g>
        </svg>

        <!-- Generator: Adobe Illustrator 28.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
        <svg
          class="g-UOB-570px-stage-socialise-md-img g-aiImg"
          version="1.2"
          baseProfile="tiny"
          id="g-UOB-2023-570px-stage-socialise-md-img"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 570 895"
          overflow="visible"
          xml:space="preserve"
        >
          <g>
            <g class="line line-s-socialise" data-name="line line-s-socialise">
              <path
                id="line:svg1"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
        M208.898,742.617h-4.029c-5.358,0-9.702-4.315-9.702-9.639V249.712c0-5.323-4.344-9.639-9.702-9.639h-19.397"
              />

              <path
                id="line:svg2"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
        M208.898,742.617h-4.029c-5.358,0-9.702-4.294-9.702-9.591V431.858h-29.099"
              />

              <path
                id="line:svg3"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
        M208.898,742.617h-4.08c-5.358,0-9.702-4.281-9.702-9.562v-236.34h-29.048"
              />

              <path
                id="line:svg4"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
        M208.898,742.617h-4.033c-5.358,0-9.702-4.229-9.702-9.446V560.748h-29.095"
              />
            </g>
            <g class="circle circle-s-socialise" data-name="circle circle-s-socialise">
              <circle id="circle:svg7" data-name="circle:svg" fill="#8095FF" cx="165.583" cy="240.073" r="2.494" />

              <circle id="circle:svg8" data-name="circle:svg" fill="#8095FF" cx="165.583" cy="431.858" r="2.494" />

              <circle id="circle:svg9" data-name="circle:svg" fill="#8095FF" cx="165.583" cy="496.715" r="2.494" />

              <circle id="circle:svg0" data-name="circle:svg" fill="#8095FF" cx="165.583" cy="560.748" r="2.494" />

              <circle id="circle:svg1" data-name="circle:svg" fill="#8095FF" cx="208.898" cy="742.617" r="2.494" />
            </g>
          </g>
        </svg>

        <!-- Generator: Adobe Illustrator 28.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
        <svg
          class="g-UOB-570px-stage-strategise-md-img g-aiImg"
          version="1.2"
          baseProfile="tiny"
          id="g-UOB-2023-570px-stage-strategise-md-img"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 570 895"
          overflow="visible"
          xml:space="preserve"
        >
          <g>
            <g class="line line-s-strategise" data-name="line line-s-strategise">
              <path
                id="line:svg5"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
        M335.468,367.818h-140.3V249.775c0-5.358-4.344-9.702-9.702-9.702h-19.397"
              />

              <polyline
                id="line:svg6"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                points="
        335.468,367.818 195.168,367.818 195.168,304.397 166.068,304.397 		"
              />

              <line
                id="line:svg7"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                x1="335.268"
                y1="367.819"
                x2="166.068"
                y2="367.819"
              />
            </g>
            <g class="circle circle-s-strategise" data-name="circle circle-s-strategise">
              <circle id="circle:svg2" data-name="circle:svg" fill="#8095FF" cx="335.302" cy="367.817" r="2.494" />

              <circle id="circle:svg3" data-name="circle:svg" fill="#8095FF" cx="165.583" cy="367.818" r="2.494" />

              <circle id="circle:svg4" data-name="circle:svg" fill="#8095FF" cx="165.583" cy="304.397" r="2.494" />

              <circle id="circle:svg5" data-name="circle:svg" fill="#8095FF" cx="165.583" cy="240.073" r="2.494" />
            </g>
          </g>
        </svg>

        <!-- Generator: Adobe Illustrator 28.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
        <svg
          class="g-UOB-570px-stage-develop-md-img g-aiImg"
          version="1.2"
          baseProfile="tiny"
          id="g-UOB-2023-570px-stage-develop-md-img"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 570 895"
          overflow="visible"
          xml:space="preserve"
        >
          <g>
            <g class="line line-s-develop" data-name="line line-s-develop">
              <path
                id="line:svg8"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
        M208.898,492.582h-4.029c-5.358,0-9.702-4.344-9.702-9.702V249.775c0-5.358-4.344-9.702-9.702-9.702h-19.397"
              />

              <path
                id="line:svg9"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
        M208.898,492.582h-4.029c-5.358,0-9.702-4.344-9.702-9.702V304.397h-29.099"
              />

              <path
                id="line:svg0"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
        M208.898,492.582h-4.029c-5.358,0-9.702-4.344-9.702-9.702V367.825h-29.099"
              />
            </g>
            <g class="circle circle-s-develop" data-name="circle circle-s-develop">
              <circle id="circle:svg6" data-name="circle:svg" fill="#8095FF" cx="208.898" cy="492.582" r="2.5" />
              <circle id="circle:svg7" data-name="circle:svg" fill="#8095FF" cx="166.068" cy="367.825" r="2.5" />
              <circle id="circle:svg8" data-name="circle:svg" fill="#8095FF" cx="166.068" cy="304.397" r="2.5" />
              <circle id="circle:svg9" data-name="circle:svg" fill="#8095FF" cx="166.068" cy="240.073" r="2.5" />
            </g>
          </g>
        </svg>

        <!-- Generator: Adobe Illustrator 28.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
        <svg
          class="g-UOB-570px-stage-operationalise-md-img g-aiImg"
          version="1.2"
          baseProfile="tiny"
          id="g-UOB-2023-570px-stage-operationalise-md-img"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 570 895"
          overflow="visible"
          xml:space="preserve"
        >
          <g>
            <g class="line line-s-operationalise" data-name="line line-s-operationalise">
              <path
                id="line:svg1"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
        M336.381,617.67H204.87c-5.358,0-9.702-4.316-9.702-9.641V249.714c0-5.325-4.344-9.641-9.702-9.641h-19.397"
              />

              <path
                id="line:svg2"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
        M336.381,617.67H204.87c-5.358,0-9.702-4.311-9.702-9.628V304.397h-29.099"
              />

              <path
                id="line:svg3"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
        M336.381,617.67H204.87c-5.358,0-9.702-4.302-9.702-9.61V367.825h-29.099"
              />

              <path
                id="line:svg4"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
        M336.381,617.67H204.87c-5.358,0-9.702-4.259-9.702-9.514V496.715h-29.099"
              />
            </g>
            <g class="circle circle-s-operationalise" data-name="circle circle-s-operationalise">
              <circle id="circle:svg-80" data-name="circle:svg" fill="#8095FF" cx="336.381" cy="617.67" r="2.5" />
              <circle id="circle:svg-81" data-name="circle:svg" fill="#8095FF" cx="165.583" cy="496.715" r="2.5" />
              <circle id="circle:svg-82" data-name="circle:svg" fill="#8095FF" cx="165.583" cy="367.825" r="2.5" />
              <circle id="circle:svg-83" data-name="circle:svg" fill="#8095FF" cx="165.583" cy="304.397" r="2.5" />
              <circle id="circle:svg-84" data-name="circle:svg" fill="#8095FF" cx="165.583" cy="240.073" r="2.5" />
            </g>
          </g>
        </svg>

        <div class="html-el">
          <div class="viz-1-header mb-30" v-if="content">
            <p class="text-body--large mb-15 font-weight-bold" style="margin-bottom: 15px">
              {{ copy.header }}
            </p>
            <p class="text-body legend"><span class="dia-icon" style="margin-right: 12px" />{{ copy.diamond }}</p>
            <p class="text-body legend"><span class="rect-icon" style="margin-right: 12px" />{{ copy.rectangle }}</p>
          </div>

          <div style="display: flex">
            <div class="viz-1-enabler-buttons">
              <p class="text-small mb-15" style="margin-bottom: 15px">Types of green FinTech enablers and where they can help</p>

              <div
                v-for="enabler in enablerData"
                :key="enabler.id"
                type="button"
                button_name="roadmap"
                :data-toggle="!showPaths ? 'modal' : ''"
                data-target="#viz-1-modal"
                @click="handleEnabler(enabler.id)"
                @mouseenter="handlePathEnabler(enabler.id)"
                @mouseleave="handleReset"
                :class="['enabler-button dtm-button', enabler.id]"
              >
                <p class="text-body font-weight-bold text-center text--primary enabler-label">{{ enabler.label }}</p>
              </div>
            </div>

            <div class="viz-1-stage-diamonds">
              <div
                type="button"
                button_name="roadmap"
                :data-toggle="!showPaths ? 'modal' : ''"
                data-target="#viz-1-modal"
                @click="handleStage('s-assess')"
                @mouseenter="handlePathStage('s-assess')"
                @mouseleave="handleReset"
                class="stage-button dtm-button s-assess"
              >
                <div class="dia-bg" />

                <div class="dia-content">
                  <viz-1-icon-assess width="23" height="19" :iconColor="iconColor" />

                  <div class="text-center">
                    <p class="text-body font-weight-bold">Assess</p>
                    <p class="text-small">Understand the company&rsquo;s sustainability landscape</p>
                  </div>
                </div>
              </div>

              <div
                type="button"
                button_name="roadmap"
                :data-toggle="!showPaths ? 'modal' : ''"
                data-target="#viz-1-modal"
                @click="handleStage('s-develop')"
                @mouseenter="handlePathStage('s-develop')"
                @mouseleave="handleReset"
                class="stage-button dtm-button s-develop"
                style="margin-top: 82.5px"
              >
                <div class="dia-bg" />

                <div class="dia-content">
                  <viz-1-icon-develop width="19" height="21" :iconColor="iconColor" />

                  <div class="text-center">
                    <p class="text-body font-weight-bold">Develop</p>
                    <p class="text-small" style="font-size: 14.1px">
                      Map key activities, identify enabling technologies and funding/resources needed
                    </p>
                  </div>
                </div>
              </div>

              <div
                type="button"
                button_name="roadmap"
                :data-toggle="!showPaths ? 'modal' : ''"
                data-target="#viz-1-modal"
                @click="handleStage('s-socialise')"
                @mouseenter="handlePathStage('s-socialise')"
                @mouseleave="handleReset"
                class="stage-button dtm-button s-socialise"
                style="margin-top: 81.5px"
              >
                <div class="dia-bg" />

                <div class="dia-content">
                  <viz-1-icon-socialise width="23" height="19" :iconColor="iconColor" />

                  <div class="text-center">
                    <p class="text-body font-weight-bold">Socialise</p>
                    <p class="text-small">Engage stakeholders, report on progress and iterate strategies</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="viz-1-stage-diamonds" style="margin-top: 128.25px; margin-left: -44px">
              <div
                type="button"
                button_name="roadmap"
                :data-toggle="!showPaths ? 'modal' : ''"
                data-target="#viz-1-modal"
                @click="handleStage('s-strategise')"
                @mouseenter="handlePathStage('s-strategise')"
                @mouseleave="handleReset"
                class="stage-button dtm-button s-strategise"
              >
                <div class="dia-bg" />

                <div class="dia-content">
                  <viz-1-icon-strategise width="21" height="21" :iconColor="iconColor" />

                  <div class="text-center">
                    <p class="text-body font-weight-bold">Strategise</p>
                    <p class="text-small">Identify most impactful areas for change, and KPIs for each</p>
                  </div>
                </div>
              </div>

              <div
                type="button"
                button_name="roadmap"
                :data-toggle="!showPaths ? 'modal' : ''"
                data-target="#viz-1-modal"
                @click="handleStage('s-operationalise')"
                @mouseenter="handlePathStage('s-operationalise')"
                @mouseleave="handleReset"
                class="stage-button dtm-button s-operationalise"
                style="margin-top: 81.5px"
              >
                <div class="dia-bg" />

                <div class="dia-content">
                  <viz-1-icon-operationalise width="15" height="21" :iconColor="iconColor" />

                  <div class="text-center">
                    <p class="text-body font-weight-bold">Operationalise</p>
                    <p class="text-small">
                      Assign responsibilities, implement activities and embed tech solutions to track KPIs
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Artboard: 395px -->
      <div
        id="g-UOB-2023-395px"
        class="g-artboard"
        style="width: 395px; height: 637px; overflow: hidden"
        data-aspect-ratio="0.62"
        data-min-width="395"
        data-max-width="569"
      >
        <!-- Generator: Adobe Illustrator 28.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
        <svg
          class="g-UOB-395px-enabler-datanalytics-sm-img g-aiImg"
          version="1.2"
          baseProfile="tiny"
          id="g-UOB-2023-395px-enabler-datanalytics-sm-img"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 395 637"
          overflow="visible"
          xml:space="preserve"
        >
          <g>
            <g class="line line-e-analytics" data-name="line line-e-analytics">
              <polyline
                id="line:svg5"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                points="
      139.61,256.765 162.439,256.765 162.439,256.765 187.916,256.765 		"
              />

              <path
                id="line:svg6"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                d="
      M139.61,256.765h27.222v298.316c0,5.523,4.477,10,10,10h10.821"
              />

              <polyline
                id="line:svg7"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                points="
      139.61,256.765 166.833,256.765 166.833,487.872 261.13,487.872 		"
              />

              <polyline
                id="line:svg8"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                points="
      139.61,256.765 166.833,256.765 166.833,411.184 187.636,411.184 		"
              />

              <polyline
                id="line:svg9"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                points="
      139.61,256.765 166.833,256.765 166.833,333.453 261.13,333.453 		"
              />
            </g>
            <g class="circle circle-e-analytics" data-name="circle circle-e-analytics">
              <circle id="circle:svg-85" data-name="circle:svg" fill="#3EB770" cx="187.654" cy="565.081" r="2.5" />
              <circle id="circle:svg-86" data-name="circle:svg" fill="#3EB770" cx="261.13" cy="487.872" r="2.5" />
              <circle id="circle:svg-87" data-name="circle:svg" fill="#3EB770" cx="187.636" cy="411.194" r="2.5" />
              <circle id="circle:svg-88" data-name="circle:svg" fill="#3EB770" cx="261.13" cy="333.453" r="2.5" />
              <circle id="circle:svg-89" data-name="circle:svg" fill="#3EB770" cx="187.636" cy="256.765" r="2.5" />
              <circle id="circle:svg-90" data-name="circle:svg" fill="#3EB770" cx="139.587" cy="256.772" r="2.5" />
            </g>
          </g>
        </svg>
        <!-- Generator: Adobe Illustrator 28.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
        <svg
          class="g-UOB-395px-enabler-datacollection-sm-img g-aiImg"
          version="1.2"
          baseProfile="tiny"
          id="g-UOB-2023-395px-enabler-datacollection-sm-img"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 395 637"
          overflow="visible"
          xml:space="preserve"
        >
          <g>
            <g class="line line-e-collection" data-name="line line-e-collection">
              <path
                id="line:svg0"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                d="
      M139.61,314.243h27.222v-47.479c0-5.523,4.477-10,10-10h10.821"
              />

              <path
                id="line:svg1"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                d="
      M139.61,314.243h27.222v163.628c0,5.523,4.477,10,10,10h84.277"
              />

              <polyline
                id="line:svg2"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                points="
      139.61,314.243 166.833,314.243 166.833,411.184 187.636,411.184 		"
              />

              <polyline
                id="line:svg3"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                points="
      139.61,314.183 166.833,314.183 166.833,333.453 261.11,333.453 		"
              />
            </g>
            <g class="circle circle-e-collection" data-name="circle circle-e-collection">
              <circle id="circle:svg-91" data-name="circle:svg" fill="#3EB770" cx="139.61" cy="314.243" r="2.5" />
              <circle id="circle:svg-92" data-name="circle:svg" fill="#3EB770" cx="188.065" cy="256.772" r="2.5" />
              <circle id="circle:svg-93" data-name="circle:svg" fill="#3EB770" cx="260.819" cy="333.453" r="2.5" />
              <circle id="circle:svg-94" data-name="circle:svg" fill="#3EB770" cx="187.636" cy="411.184" r="2.5" />
              <circle id="circle:svg-95" data-name="circle:svg" fill="#3EB770" cx="261.11" cy="487.872" r="2.5" />
            </g>
          </g>
        </svg>
        <!-- Generator: Adobe Illustrator 28.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
        <svg
          class="g-UOB-395px-enabler-carbonservices-sm-img g-aiImg"
          version="1.2"
          baseProfile="tiny"
          id="g-UOB-2023-395px-enabler-carbonservices-sm-img"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 395 637"
          overflow="visible"
          xml:space="preserve"
        >
          <g>
            <g class="line line-e-carbon" data-name="line line-e-carbon">
              <path
                id="line:svg4"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                d="
      M139.61,372.243h27.222v105.628c0,5.523,4.477,10,10,10h84.277"
              />

              <polyline
                id="line:svg5"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                points="
      139.61,372.243 166.833,372.243 166.833,411.184 187.636,411.184 		"
              />

              <path
                id="line:svg6"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                d="
      M139.61,372.243h27.222v-28.791c0-5.523,4.477-10,10-10h84.277"
              />
            </g>
            <g class="circle circle-e-carbon" data-name="circle circle-e-carbon">
              <circle id="circle:svg-96" data-name="circle:svg" fill="#3EB770" cx="261.11" cy="333.453" r="2.5" />
              <circle id="circle:svg-97" data-name="circle:svg" fill="#3EB770" cx="187.636" cy="411.194" r="2.5" />
              <circle id="circle:svg-98" data-name="circle:svg" fill="#3EB770" cx="261.11" cy="487.872" r="2.5" />
              <circle id="circle:svg-99" data-name="circle:svg" fill="#3EB770" cx="139.587" cy="372.243" r="2.5" />
            </g>
          </g>
        </svg>
        <!-- Generator: Adobe Illustrator 28.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
        <svg
          class="g-UOB-395px-enabler-reporting-sm-img g-aiImg"
          version="1.2"
          baseProfile="tiny"
          id="g-UOB-2023-395px-enabler-reporting-sm-img"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 395 637"
          overflow="visible"
          xml:space="preserve"
        >
          <g>
            <g class="line line-e-reporting" data-name="line line-e-reporting">
              <path
                id="line:svg7"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                d="
      M139.61,430.243l17.222-0.001c5.523,0,10,4.477,10,10V555.08c0,5.523,4.477,10,10,10l10.804,0.001"
              />
            </g>
            <g class="circle circle-e-reporting" data-name="circle circle-e-reporting">
              <circle id="circle:svg00" data-name="circle:svg" fill="#3EB770" cx="187.636" cy="565.081" r="2.5" />
              <circle id="circle:svg01" data-name="circle:svg" fill="#3EB770" cx="139.488" cy="430.243" r="2.5" />
            </g>
          </g>
        </svg>
        <!-- Generator: Adobe Illustrator 28.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
        <svg
          class="g-UOB-395px-enabler-infrastructure-sm-img g-aiImg"
          version="1.2"
          baseProfile="tiny"
          id="g-UOB-2023-395px-enabler-infrastructure-sm-img"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 395 637"
          overflow="visible"
          xml:space="preserve"
        >
          <g>
            <g class="line line-e-infrastructure" data-name="line line-e-infrastructure">
              <path
                id="line:svg8"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                d="
      M139.61,487.872h27.222v67.21c0,5.523,4.477,10,10,10h10.804"
              />

              <polyline
                id="line:svg9"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                points="
      139.61,487.872 160.957,487.872 160.957,487.872 261.13,487.872 		"
              />
            </g>
            <g class="circle circle-e-infrastructure" data-name="circle circle-e-infrastructure">
              <circle id="circle:svg02" data-name="circle:svg" fill="#3EB770" cx="139.587" cy="487.872" r="2.5" />
              <circle id="circle:svg03" data-name="circle:svg" fill="#3EB770" cx="261.13" cy="487.872" r="2.5" />
              <circle id="circle:svg04" data-name="circle:svg" fill="#3EB770" cx="187.656" cy="565.119" r="2.5" />
            </g>
          </g>
        </svg>
        <!-- Generator: Adobe Illustrator 28.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
        <svg
          class="g-UOB-395px-enabler-regtech-sm-img g-aiImg"
          version="1.2"
          baseProfile="tiny"
          id="g-UOB-2023-395px-enabler-regtech-sm-img"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 395 637"
          overflow="visible"
          xml:space="preserve"
        >
          <g>
            <g class="line line-e-regtech" data-name="line line-e-regtech">
              <path
                id="line:svg-80"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                d="
      M139.61,545.872h17.222c5.523,0,10,4.477,10,10l0,0c0,5.086,4.123,9.209,9.209,9.209h11.594"
              />
            </g>
            <g class="circle circle-e-regtech" data-name="circle circle-e-regtech">
              <circle id="circle:svg05" data-name="circle:svg" fill="#3EB770" cx="139.587" cy="545.872" r="2.5" />
              <circle id="circle:svg06" data-name="circle:svg" fill="#3EB770" cx="187.636" cy="565.637" r="2.5" />
            </g>
          </g>
        </svg>
        <!-- Generator: Adobe Illustrator 28.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
        <svg
          class="g-UOB-395px-stage-assess-sm-img g-aiImg"
          version="1.2"
          baseProfile="tiny"
          id="g-UOB-2023-395px-stage-assess-sm-img"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 395 637"
          overflow="visible"
          xml:space="preserve"
        >
          <g>
            <g class="line line-s-assess" data-name="line line-s-assess">
              <path
                id="line:svg-81"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
      M139.61,256.765h27.222v47.479c0,5.523-4.477,10-10,10h-17.246"
              />

              <line
                id="line:svg-82"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                x1="139.61"
                y1="256.765"
                x2="187.638"
                y2="256.765"
              />
            </g>
            <g class="circle circle-s-assess" data-name="circles:assess:svg">
              <circle id="circle:svg07" data-name="circle:svg" fill="#8095FF" cx="139.587" cy="314.243" r="2.5" />
              <circle id="circle:svg08" data-name="circle:svg" fill="#8095FF" cx="139.587" cy="256.765" r="2.5" />
              <circle id="circle:svg09" data-name="circle:svg" fill="#8095FF" cx="188.065" cy="256.765" r="2.5" />
            </g>
          </g>
        </svg>
        <!-- Generator: Adobe Illustrator 28.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
        <svg
          class="g-UOB-395px-stage-strategise-sm-img g-aiImg"
          version="1.2"
          baseProfile="tiny"
          id="g-UOB-2023-395px-stage-strategise-sm-img"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 395 637"
          overflow="visible"
          xml:space="preserve"
        >
          <g>
            <g class="line line-s-strategise" data-name="line line-s-strategise">
              <path
                id="line:svg-83"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
      M261.13,333.453h-94.297v-66.688c0-5.523-4.429-10-9.892-10h-17.353"
              />

              <polyline
                id="line:svg-84"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                points="
      261.13,333.453 166.833,333.453 166.833,314.182 139.587,314.182 		"
              />

              <path
                id="line:svg-85"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
      M261.13,333.453h-94.297v28.791c0,5.523-4.477,10-10,10h-17.246"
              />
            </g>
            <g class="circle circle-s-strategise" data-name="circle circle-s-strategise">
              <circle id="circle:svg10" data-name="circle:svg" fill="#8095FF" cx="261.13" cy="333.69" r="2.5" />
              <circle id="circle:svg11" data-name="circle:svg" fill="#8095FF" cx="139.587" cy="372.243" r="2.5" />
              <circle id="circle:svg12" data-name="circle:svg" fill="#8095FF" cx="139.587" cy="314.243" r="2.5" />
              <circle id="circle:svg13" data-name="circle:svg" fill="#8095FF" cx="139.587" cy="256.772" r="2.5" />
            </g>
          </g>
        </svg>
        <!-- Generator: Adobe Illustrator 28.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
        <svg
          class="g-UOB-395px-stage-develop-sm-img g-aiImg"
          version="1.2"
          baseProfile="tiny"
          id="g-UOB-2023-395px-stage-develop-sm-img"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 395 637"
          overflow="visible"
          xml:space="preserve"
        >
          <g>
            <g class="line line-s-develop" data-name="lines:develop:svg">
              <path
                id="line:svg-86"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
      M188.057,411.184h-11.225c-5.523,0-10-4.477-10-10V266.765c0-5.523-4.477-10-10-10h-17.246"
              />

              <path
                id="line:svg-87"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
      M187.636,411.184h-10.891c-5.475,0-9.913-4.477-9.913-10v-87.001h-27.246"
              />

              <path
                id="line:svg-88"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
      M187.636,411.184h-10.891c-5.475,0-9.913-4.477-9.913-10v-28.94h-27.246"
              />
            </g>
            <g class="circle circle-s-develop" data-name="circles:develop:svg">
              <circle id="circle:svg14" data-name="circle:svg" fill="#8095FF" cx="187.636" cy="411.194" r="2.5" />
              <circle id="circle:svg15" data-name="circle:svg" fill="#8095FF" cx="139.587" cy="372.243" r="2.5" />
              <circle id="circle:svg16" data-name="circle:svg" fill="#8095FF" cx="139.587" cy="314.243" r="2.5" />
              <circle id="circle:svg17" data-name="circle:svg" fill="#8095FF" cx="139.587" cy="256.772" r="2.5" />
            </g>
          </g>
        </svg>
        <!-- Generator: Adobe Illustrator 28.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
        <svg
          class="g-UOB-395px-stage-operationalise-sm-img g-aiImg"
          version="1.2"
          baseProfile="tiny"
          id="g-UOB-2023-395px-stage-operationalise-sm-img"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 395 637"
          overflow="visible"
          xml:space="preserve"
        >
          <g>
            <g class="line line-s-operationalise" data-name="line line-s-operationalise">
              <path
                id="line:svg-89"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
      M261.125,487.872h-94.293V266.765c0-5.523-4.477-10-10-10h-17.246"
              />

              <polyline
                id="line:svg-90"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                points="
      261.125,487.872 166.833,487.872 166.833,314.182 139.587,314.182 		"
              />

              <polyline
                id="line:svg-91"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                points="
      261.112,487.872 166.833,487.872 166.833,372.243 139.587,372.243 		"
              />

              <line
                id="line:svg-92"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                x1="261.112"
                y1="487.872"
                x2="139.587"
                y2="487.872"
              />
            </g>
            <g class="circle circle-s-operationalise" data-name="circle-operationalise:svg">
              <circle id="circle:svg18" data-name="circle:svg" fill="#8095FF" cx="139.587" cy="256.765" r="2.5" />
              <circle id="circle:svg19" data-name="circle:svg" fill="#8095FF" cx="139.587" cy="314.243" r="2.5" />
              <circle id="circle:svg20" data-name="circle:svg" fill="#8095FF" cx="139.587" cy="372.243" r="2.5" />
              <circle id="circle:svg21" data-name="circle:svg" fill="#8095FF" cx="139.587" cy="487.872" r="2.5" />
              <circle id="circle:svg22" data-name="circle:svg" fill="#8095FF" cx="261.125" cy="487.872" r="2.5" />
            </g>
          </g>
        </svg>
        <!-- Generator: Adobe Illustrator 28.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
        <svg
          class="g-UOB-395px-stage-socialise-sm-img g-aiImg"
          version="1.2"
          baseProfile="tiny"
          id="g-UOB-2023-395px-stage-socialise-sm-img"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 395 637"
          overflow="visible"
          xml:space="preserve"
        >
          <g>
            <g class="line line-s-socialise" data-name="line line-s-socialise">
              <path
                id="line:svg-93"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
      M187.636,565.081h-10.804c-5.523,0-10-4.477-10-10V266.765c0-5.523-4.477-10-10-10h-17.246"
              />

              <path
                id="line:svg-94"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
      M187.636,565.081h-10.804c-5.523,0-10-4.477-10-10V430.243h-27.246"
              />

              <path
                id="line:svg-95"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
      M187.636,565.081H176.81c-5.523,0-10-4.477-10-10v-67.21h-27.223"
              />

              <path
                id="line:svg-96"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
      M187.636,565.081h-10.804c-5.523,0-10-4.477-10-10v-9.211h-27.246"
              />
            </g>
            <g class="circle circle-s-socialise" data-name="circle circle-s-socialise">
              <circle id="circle:svg23" data-name="circle:svg" fill="#8095FF" cx="139.587" cy="256.772" r="2.5" />
              <circle id="circle:svg24" data-name="circle:svg" fill="#8095FF" cx="139.587" cy="430.057" r="2.5" />
              <circle id="circle:svg25" data-name="circle:svg" fill="#8095FF" cx="139.587" cy="487.872" r="2.5" />
              <circle id="circle:svg26" data-name="circle:svg" fill="#8095FF" cx="139.587" cy="545.872" r="2.5" />
              <circle id="circle:svg27" data-name="circle:svg" fill="#8095FF" cx="187.636" cy="565.082" r="2.5" />
            </g>
          </g>
        </svg>

        <div class="html-el">
          <div class="viz-1-header" v-if="content">
            <p class="text-body--large mb-15 font-weight-bold" style="margin-bottom: 15px;">
              {{ copy.header }}
            </p>
            <p class="text-body legend"><span class="dia-icon" style="margin-right: 10px" />{{ copy.diamond }}</p>
            <p class="text-body legend"><span class="rect-icon" style="margin-right: 8px" />{{ copy.rectangle }}</p>
          </div>

          <div style="display: flex">
            <div class="viz-1-enabler-buttons">
              <p class="text-small text-center mb-15" style="font-size: 12.5px; margin-bottom: 15px">
                Types of green FinTech enablers and where they can help
              </p>
              <div
                v-for="enabler in enablerData"
                :key="enabler.id"
                type="button"
                button_name="roadmap"
                :data-toggle="!showPaths ? 'modal' : ''"
                data-target="#viz-1-modal"
                @click="handleEnabler(enabler.id)"
                @mouseenter="handlePathEnabler(enabler.id)"
                @mouseleave="handleReset"
                :class="['enabler-button dtm-button', enabler.id]"
              >
                <p class="text-body font-weight-bold text-center text--primary enabler-label">{{ enabler.label }}</p>
              </div>
            </div>

            <div class="viz-1-stage-diamonds">
              <div
                type="button"
                button_name="roadmap"
                :data-toggle="!showPaths ? 'modal' : ''"
                data-target="#viz-1-modal"
                @click="handleStage('s-assess')"
                @mouseenter="handlePathStage('s-assess')"
                @mouseleave="handleReset"
                class="stage-button dtm-button s-assess"
              >
                <div class="dia-bg" />

                <div class="dia-content">
                  <viz-1-icon-assess width="23" height="19" :iconColor="iconColor" />

                  <div class="text-center">
                    <p class="text-body font-weight-bold">Assess</p>
                  </div>
                </div>
              </div>

              <div
                type="button"
                button_name="roadmap"
                :data-toggle="!showPaths ? 'modal' : ''"
                data-target="#viz-1-modal"
                @click="handleStage('s-develop')"
                @mouseenter="handlePathStage('s-develop')"
                @mouseleave="handleReset"
                class="stage-button dtm-button s-develop"
                style="margin-top: 54.5px"
              >
                <div class="dia-bg" />

                <div class="dia-content">
                  <viz-1-icon-develop width="19" height="21" :iconColor="iconColor" />

                  <div class="text-center">
                    <p class="text-body font-weight-bold">Develop</p>
                  </div>
                </div>
              </div>

              <div
                type="button"
                button_name="roadmap"
                :data-toggle="!showPaths ? 'modal' : ''"
                data-target="#viz-1-modal"
                @click="handleStage('s-socialise')"
                @mouseenter="handlePathStage('s-socialise')"
                @mouseleave="handleReset"
                class="stage-button dtm-button s-socialise"
                style="margin-top: 54.5px"
              >
                <div class="dia-bg" />

                <div class="dia-content">
                  <viz-1-icon-socialise width="23" height="19" :iconColor="iconColor" />

                  <div class="text-center">
                    <p class="text-body font-weight-bold">Socialise</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="viz-1-stage-diamonds" style="margin-top: 77.25px; margin-left: -28px">
              <div
                type="button"
                button_name="roadmap"
                :data-toggle="!showPaths ? 'modal' : ''"
                data-target="#viz-1-modal"
                @click="handleStage('s-strategise')"
                @mouseenter="handlePathStage('s-strategise')"
                @mouseleave="handleReset"
                class="stage-button dtm-button s-strategise"
              >
                <div class="dia-bg" />

                <div class="dia-content">
                  <viz-1-icon-strategise width="21" height="21" :iconColor="iconColor" />

                  <div class="text-center">
                    <p class="text-body font-weight-bold">Strategise</p>
                  </div>
                </div>
              </div>

              <div
                type="button"
                button_name="roadmap"
                :data-toggle="!showPaths ? 'modal' : ''"
                data-target="#viz-1-modal"
                @click="handleStage('s-operationalise')"
                @mouseenter="handlePathStage('s-operationalise')"
                @mouseleave="handleReset"
                class="stage-button dtm-button s-operationalise"
                style="margin-top: 54.5px"
              >
                <div class="dia-bg" />

                <div class="dia-content">
                  <viz-1-icon-operationalise width="15" height="21" :iconColor="iconColor" />

                  <div class="text-center">
                    <p class="text-body font-weight-bold">Operationalise</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Artboard: 320px -->
      <div
        id="g-UOB-2023-320px"
        class="g-artboard"
        style="max-width: 320px; max-height: 789px; overflow: hidden"
        data-aspect-ratio="0.406"
        data-min-width="0"
        data-max-width="394"
      >
        <div style="padding: 0 0 246.5625% 0"></div>

        <!-- Generator: Adobe Illustrator 28.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
        <svg
          class="g-UOB-320px-enabler-dataanalytics-xs-img g-aiImg"
          version="1.2"
          baseProfile="tiny"
          id="g-UOB-2023-320px-enabler-dataanalytics-xs-img"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 320 789"
          overflow="visible"
          xml:space="preserve"
        >
          <g>
            <g class="line line-e-analytics" data-name="line line-e-analytics">
              <path
                id="line:svg-97"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                d="
        M140.029,267.293h35.363v-40.809c0-2.761,2.239-5,5-5h21.917"
              />

              <polyline
                id="line:svg-98"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                points="
        140.78,267.293 175.392,267.293 175.392,348.432 202.294,348.432 		"
              />

              <polyline
                id="line:svg-99"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                points="
        140.78,267.293 175.392,267.293 175.392,476.196 202.294,476.196 		"
              />

              <polyline
                id="line:svg00"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                points="
        140.78,267.293 175.392,267.293 175.392,603.039 202.294,603.039 		"
              />

              <path
                id="line:svg01"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                d="
        M140.78,267.293h34.612v457.526c0,2.761,2.239,5,5,5h21.902"
              />
            </g>
            <g class="circle circle-e-analytics" data-name="circle circle-e-analytics">
              <circle id="circle:svg28" data-name="circle:svg" fill="#3EB770" cx="139.917" cy="267.584" r="2.5" />
              <circle id="circle:svg29" data-name="circle:svg" fill="#3EB770" cx="202.197" cy="221.485" r="2.5" />
              <circle id="circle:svg30" data-name="circle:svg" fill="#3EB770" cx="202.197" cy="348.432" r="2.5" />
              <circle id="circle:svg31" data-name="circle:svg" fill="#3EB770" cx="202.197" cy="476.196" r="2.5" />
              <circle id="circle:svg32" data-name="circle:svg" fill="#3EB770" cx="202.197" cy="603.039" r="2.5" />
              <circle id="circle:svg33" data-name="circle:svg" fill="#3EB770" cx="202.197" cy="729.819" r="2.5" />
            </g>
          </g>
        </svg>

        <!-- Generator: Adobe Illustrator 28.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
        <svg
          class="g-UOB-320px-enabler-datacollection-xs-img g-aiImg"
          version="1.2"
          baseProfile="tiny"
          id="g-UOB-2023-320px-enabler-datacollection-xs-img"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 320 789"
          overflow="visible"
          xml:space="preserve"
        >
          <g>
            <g class="line line-e-collection" data-name="line line-e-collection">
              <path
                id="line:svg02"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                d="
        M140.029,325.293h35.363v-91.921v-6.888c0-2.761,2.239-5,5-5h21.917"
              />

              <polyline
                id="line:svg03"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                points="
        140.78,325.293 175.392,325.293 175.392,348.432 202.294,348.432 		"
              />

              <polyline
                id="line:svg04"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                points="
        140.78,325.293 175.392,325.293 175.392,476.196 202.294,476.196 		"
              />

              <path
                id="line:svg05"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                d="
        M140.78,325.293h34.612v272.746c0,2.761,2.239,5,5,5h21.902"
              />
            </g>
            <g class="circle circle-e-collection" data-name="circle circle-e-collection">
              <circle id="circle:svg34" data-name="circle:svg" fill="#3EB770" cx="139.917" cy="325.293" r="2.5" />
              <circle id="circle:svg35" data-name="circle:svg" fill="#3EB770" cx="202.197" cy="221.484" r="2.5" />
              <circle id="circle:svg36" data-name="circle:svg" fill="#3EB770" cx="202.197" cy="348.432" r="2.5" />
              <circle id="circle:svg37" data-name="circle:svg" fill="#3EB770" cx="202.197" cy="476.196" r="2.5" />
              <circle id="circle:svg38" data-name="circle:svg" fill="#3EB770" cx="202.197" cy="603.039" r="2.5" />
            </g>
          </g>
        </svg>

        <!-- Generator: Adobe Illustrator 28.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
        <svg
          class="g-UOB-320px-enabler-carbonservices-xs-img g-aiImg"
          version="1.2"
          baseProfile="tiny"
          id="g-UOB-2023-320px-enabler-carbonservices-xs-img"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 320 789"
          overflow="visible"
          xml:space="preserve"
        >
          <g>
            <g class="line line-e-carbon" data-name="line line-e-carbon">
              <path
                id="line:svg06"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                d="
        M140.78,383.293h34.612v-29.861c0-2.761,2.239-5,5-5h21.902"
              />

              <polyline
                id="line:svg07"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                points="
        140.78,383.324 175.392,383.324 175.392,476.196 202.294,476.196 		"
              />

              <path
                id="line:svg08"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                d="
        M140.78,383.293h34.612v215.79c0,2.185,2.239,3.956,5,3.956h21.902"
              />
            </g>
            <g class="circle circle-e-carbon" data-name="circle circle-e-carbon">
              <circle id="circle:svg39" data-name="circle:svg" fill="#3EB770" cx="139.917" cy="383.293" r="2.5" />
              <circle id="circle:svg40" data-name="circle:svg" fill="#3EB770" cx="202.197" cy="348.432" r="2.5" />
              <circle id="circle:svg41" data-name="circle:svg" fill="#3EB770" cx="202.197" cy="476.196" r="2.5" />
              <circle id="circle:svg42" data-name="circle:svg" fill="#3EB770" cx="202.197" cy="603.039" r="2.5" />
            </g>
          </g>
        </svg>

        <!-- Generator: Adobe Illustrator 28.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
        <svg
          class="g-UOB-320px-enabler-reporting-xs-img g-aiImg"
          version="1.2"
          baseProfile="tiny"
          id="g-UOB-2023-320px-enabler-reporting-xs-img"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 320 789"
          overflow="visible"
          xml:space="preserve"
        >
          <g>
            <g class="line line-e-reporting" data-name="line line-e-reporting">
              <path
                id="line:svg09"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                d="
        M140.78,441.293h29.612c2.761,0,5,2.239,5,5v277.58c0,3.913,2.239,7.084,5,7.084h21.902"
              />
            </g>
            <g class="circle circle-e-reporting" data-name="circle circle-e-reporting">
              <circle id="circle:svg43" data-name="circle:svg" fill="#3EB770" cx="139.917" cy="441.293" r="2.5" />
              <circle id="circle:svg44" data-name="circle:svg" fill="#3EB770" cx="202.294" cy="730.957" r="2.5" />
            </g>
          </g>
        </svg>

        <!-- Generator: Adobe Illustrator 28.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
        <svg
          class="g-UOB-320px-enabler-infrastructure-xs-img g-aiImg"
          version="1.2"
          baseProfile="tiny"
          id="g-UOB-2023-320px-enabler-infrastructure-xs-img"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 320 789"
          overflow="visible"
          xml:space="preserve"
        >
          <g>
            <g class="line line-e-infrastructure" data-name="line line-e-infrastructure">
              <path
                id="line:svg10"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                d="
        M140.78,498.921h29.612c2.761,0,5,2.239,5,5v98.761h26.902"
              />

              <path
                id="line:svg11"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                d="
        M140.78,498.921h29.612c2.761,0,5,2.239,5,5v221.821c0,2.88,2.239,5.215,5,5.215h21.902"
              />
            </g>
            <g class="circle circle-e-infrastructure" data-name="circle circle-e-infrastructure">
              <circle id="circle:svg45" data-name="circle:svg" fill="#3EB770" cx="139.917" cy="498.921" r="2.5" />
              <circle id="circle:svg46" data-name="circle:svg" fill="#3EB770" cx="202.197" cy="603.039" r="2.5" />
              <circle id="circle:svg47" data-name="circle:svg" fill="#3EB770" cx="202.197" cy="730.957" r="2.5" />
            </g>
          </g>
        </svg>

        <!-- Generator: Adobe Illustrator 28.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
        <svg
          class="g-UOB-320px-enabler-regtech-xs-img g-aiImg"
          version="1.2"
          baseProfile="tiny"
          id="g-UOB-2023-320px-enabler-regtech-xs-img"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 320 789"
          overflow="visible"
          xml:space="preserve"
        >
          <g>
            <g class="line line-e-regtech" data-name="line line-e-regtech">
              <path
                id="line:svg12"
                data-name="line:svg"
                fill="none"
                stroke="#3EB770"
                stroke-miterlimit="10"
                d="
        M140.78,556.921h29.612c2.761,0,5,2.239,5,5v163.821c0,2.88,2.239,5.215,5,5.215h21.902"
              />
            </g>
            <g class="circle circle-e-regtech" data-name="circle circle-e-regtech">
              <circle id="circle:svg48" data-name="circle:svg" fill="#3EB770" cx="139.917" cy="556.921" r="2.5" />
              <circle id="circle:svg49" data-name="circle:svg" fill="#3EB770" cx="202.197" cy="730.957" r="2.5" />
            </g>
          </g>
        </svg>

        <!-- Generator: Adobe Illustrator 28.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
        <svg
          class="g-UOB-320px-stage-assess-xs-img g-aiImg"
          version="1.2"
          baseProfile="tiny"
          id="g-UOB-2023-320px-stage-assess-xs-img"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 320 789"
          overflow="visible"
          xml:space="preserve"
        >
          <g>
            <g class="line line-s-assess" data-name="line line-s-assess">
              <path
                id="line:svg13"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
        M202.294,221.485h-21.902c-2.761,0-5,2.239-5,5v40.808h-35.363"
              />

              <path
                id="line:svg14"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
        M202.294,221.485h-21.902c-2.761,0-5,2.239-5,5v93.808c0,2.761-2.239,5-5,5h-30.363"
              />
            </g>
            <g class="circle circle-s-assess" data-name="circle circle-s-assess">
              <circle id="circle:svg50" data-name="circle:svg" fill="#8095FF" cx="139.917" cy="325.293" r="2.5" />
              <circle id="circle:svg51" data-name="circle:svg" fill="#8095FF" cx="139.917" cy="267.293" r="2.5" />
              <circle id="circle:svg52" data-name="circle:svg" fill="#8095FF" cx="202.294" cy="221.485" r="2.5" />
            </g>
          </g>
        </svg>

        <!-- Generator: Adobe Illustrator 28.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
        <svg
          class="g-UOB-320px-stage-strategise-xs-img g-aiImg"
          version="1.2"
          baseProfile="tiny"
          id="g-UOB-2023-320px-stage-strategise-xs-img"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 320 789"
          overflow="visible"
          xml:space="preserve"
        >
          <g>
            <g class="line line-s-strategise" data-name="line line-s-strategise">
              <polyline
                id="line:svg15"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                points="
        202.294,348.432 175.392,348.432 175.392,325.293 139.917,325.293 		"
              />

              <path
                id="line:svg16"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
        M202.294,348.432h-26.902v-76.139c0-2.761-2.239-5-5-5h-30.475"
              />

              <path
                id="line:svg17"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
        M202.294,348.432h-26.902v29.861c0,2.761-2.239,5-5,5h-30.475"
              />
            </g>
            <g class="circle circle-s-strategise" data-name="circle circle-s-strategise">
              <circle id="circle:svg53" data-name="circle:svg" fill="#8095FF" cx="139.917" cy="325.293" r="2.5" />
              <circle id="circle:svg54" data-name="circle:svg" fill="#8095FF" cx="202.294" cy="348.432" r="2.5" />
              <circle id="circle:svg55" data-name="circle:svg" fill="#8095FF" cx="139.917" cy="267.293" r="2.5" />
              <circle id="circle:svg56" data-name="circle:svg" fill="#8095FF" cx="140.029" cy="383.293" r="2.5" />
            </g>
          </g>
        </svg>

        <!-- Generator: Adobe Illustrator 28.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
        <svg
          class="g-UOB-320px-stage-develop-xs-img g-aiImg"
          version="1.2"
          baseProfile="tiny"
          id="g-UOB-2023-320px-stage-develop-xs-img"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 320 789"
          overflow="visible"
          xml:space="preserve"
        >
          <g>
            <g class="line line-s-develop" data-name="line line-s-develop">
              <path
                id="line:svg18"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
        M202.294,476.196h-21.902c-2.761,0-5-2.239-5-5V325.293h-35.475"
              />

              <path
                id="line:svg19"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
        M202.294,476.196h-21.902c-2.761,0-5-2.239-5-5V272.293c0-2.761-2.239-5-5-5h-30.475"
              />

              <path
                id="line:svg20"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
        M202.294,476.196h-21.902c-2.761,0-5-2.239-5-5v-87.903h-35.475"
              />
            </g>
            <g class="circle circle-s-develop" data-name="circle circle-s-develop">
              <circle id="circle:svg57" data-name="circle:svg" fill="#8095FF" cx="139.917" cy="325.293" r="2.5" />
              <circle id="circle:svg58" data-name="circle:svg" fill="#8095FF" cx="202.294" cy="476.196" r="2.5" />
              <circle id="circle:svg59" data-name="circle:svg" fill="#8095FF" cx="139.917" cy="267.293" r="2.5" />
              <circle id="circle:svg60" data-name="circle:svg" fill="#8095FF" cx="140.029" cy="383.293" r="2.5" />
            </g>
          </g>
        </svg>

        <!-- Generator: Adobe Illustrator 28.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
        <svg
          class="g-UOB-320px-stage-operationalise-xs-img g-aiImg"
          version="1.2"
          baseProfile="tiny"
          id="g-UOB-2023-320px-stage-operationalise-xs-img"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 320 789"
          overflow="visible"
          xml:space="preserve"
        >
          <g>
            <g class="line line-s-operationalise" data-name="line line-s-operationalise">
              <path
                id="line:svg21"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
        M202.294,603.039h-21.902c-2.761,0-5-2.239-5-5V325.293h-35.475"
              />

              <path
                id="line:svg22"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
        M202.294,603.039h-21.902c-2.761,0-5-2.239-5-5V272.293c0-2.761-2.239-5-5-5h-30.475"
              />

              <path
                id="line:svg23"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
        M202.294,603.039h-21.902c-2.761,0-5-2.239-5-5V383.293h-35.475"
              />

              <path
                id="line:svg24"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
        M202.294,603.039h-21.902c-2.761,0-5-2.239-5-5v-99.118h-35.475"
              />
            </g>
            <g class="circle circle-s-operationalise" data-name="circle circle-s-operationalise">
              <circle id="circle:svg61" data-name="circle:svg" fill="#8095FF" cx="139.917" cy="325.293" r="2.5" />
              <circle id="circle:svg62" data-name="circle:svg" fill="#8095FF" cx="202.294" cy="603.039" r="2.5" />
              <circle id="circle:svg63" data-name="circle:svg" fill="#8095FF" cx="139.917" cy="267.293" r="2.5" />
              <circle id="circle:svg64" data-name="circle:svg" fill="#8095FF" cx="140.029" cy="383.293" r="2.5" />
              <circle id="circle:svg65" data-name="circle:svg" fill="#8095FF" cx="140.029" cy="498.921" r="2.5" />
            </g>
          </g>
        </svg>

        <!-- Generator: Adobe Illustrator 28.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
        <svg
          class="g-UOB-320px-stage-socialise-xs-img g-aiImg"
          version="1.2"
          baseProfile="tiny"
          id="g-UOB-2023-320px-stage-socialise-xs-img"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 320 789"
          overflow="visible"
          xml:space="preserve"
        >
          <g>
            <g class="line line-s-socialise" data-name="line line-s-socialise">
              <path
                id="line:svg25"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
        M202.294,729.819h-21.902c-2.761,0-5-2.239-5-5V272.293c0-2.761-2.239-5-5-5h-30.475"
              />

              <path
                id="line:svg26"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
        M202.294,729.819h-21.902c-2.761,0-5-2.239-5-5V446.293c0-2.761-2.239-5-5-5h-30.475"
              />

              <path
                id="line:svg27"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
        M202.294,729.819h-21.902c-2.761,0-5-2.239-5-5V498.921h-35.475"
              />

              <path
                id="line:svg28"
                data-name="line:svg"
                fill="none"
                stroke="#8095FF"
                stroke-miterlimit="10"
                d="
        M202.294,729.819h-21.902c-2.761,0-5-2.239-5-5V556.921h-35.475"
              />
            </g>
            <g class="circle circle-s-socialise" data-name="circle circle-s-socialise">
              <circle id="circle:svg66" data-name="circle:svg" fill="#8095FF" cx="139.917" cy="441.293" r="2.5" />
              <circle id="circle:svg67" data-name="circle:svg" fill="#8095FF" cx="202.294" cy="729.819" r="2.5" />
              <circle id="circle:svg68" data-name="circle:svg" fill="#8095FF" cx="139.917" cy="267.293" r="2.5" />
              <circle id="circle:svg69" data-name="circle:svg" fill="#8095FF" cx="140.029" cy="498.921" r="2.5" />
              <circle id="circle:svg70" data-name="circle:svg" fill="#8095FF" cx="140.029" cy="556.921" r="2.5" />
            </g>
          </g>
        </svg>

        <div class="html-el">
          <div class="viz-1-header" v-if="content">
            <p class="text-body--large mb-15 font-weight-bold" style="margin-bottom: 15px;">
              {{ copy.header }}
            </p>
            <p class="text-body legend" style="line-height: 20.3px"><span class="dia-icon" style="margin-right: 10px" />{{ copy.diamond }}</p>
            <p class="text-body legend" style="line-height: 20.3px"><span class="rect-icon" style="margin-right: 8px" />{{ copy.rectangle }}</p>
          </div>

          <div style="display: flex">
            <div class="viz-1-enabler-buttons">
              <p class="text-small text-center mb-15" style="font-size: 12.5px; margin-bottom: 15px;">
                Types of green FinTech enablers and where they can help
              </p>
              <div
                v-for="enabler in enablerData"
                :key="enabler.id"
                type="button"
                button_name="roadmap"
                :data-toggle="!showPaths ? 'modal' : ''"
                data-target="#viz-1-modal"
                @click="handleEnabler(enabler.id)"
                :class="['enabler-button dtm-button', enabler.id]"
              >
                <p class="text-body font-weight-bold text-center text--primary enabler-label">{{ enabler.label }}</p>
              </div>
            </div>

            <div class="viz-1-stage-diamonds">
              <div
                type="button"
                button_name="roadmap"
                :data-toggle="!showPaths ? 'modal' : ''"
                data-target="#viz-1-modal"
                @click="handleStage('s-assess')"
                class="stage-button dtm-button s-assess"
              >
                <div class="dia-bg" />

                <div class="dia-content">
                  <viz-1-icon-assess width="23" height="19" :iconColor="iconColor" />

                  <div class="text-center">
                    <p class="text-body font-weight-bold mobile-diamond">Assess</p>
                  </div>
                </div>
              </div>

              <div
                type="button"
                button_name="roadmap"
                :data-toggle="!showPaths ? 'modal' : ''"
                data-target="#viz-1-modal"
                @click="handleStage('s-strategise')"
                class="stage-button dtm-button s-strategise"
                style="margin-top: 38px"
              >
                <div class="dia-bg" />

                <div class="dia-content">
                  <viz-1-icon-strategise width="21" height="21" :iconColor="iconColor" />

                  <div class="text-center">
                    <p class="text-body font-weight-bold mobile-diamond">Strategise</p>
                  </div>
                </div>
              </div>

              <div
                type="button"
                button_name="roadmap"
                :data-toggle="!showPaths ? 'modal' : ''"
                data-target="#viz-1-modal"
                @click="handleStage('s-develop')"
                class="stage-button dtm-button s-develop"
                style="margin-top: 38.5px"
              >
                <div class="dia-bg" />

                <div class="dia-content">
                  <viz-1-icon-develop width="19" height="21" :iconColor="iconColor" />

                  <div class="text-center">
                    <p class="text-body font-weight-bold mobile-diamond">Develop</p>
                  </div>
                </div>
              </div>

              <div
                type="button"
                button_name="roadmap"
                :data-toggle="!showPaths ? 'modal' : ''"
                data-target="#viz-1-modal"
                @click="handleStage('s-operationalise')"
                class="stage-button dtm-button s-operationalise"
                style="margin-top: 42.5px"
              >
                <div class="dia-bg" />

                <div class="dia-content">
                  <viz-1-icon-operationalise width="15" height="21" :iconColor="iconColor" />

                  <div class="text-center">
                    <p class="text-body font-weight-bold mobile-diamond">Operationalise</p>
                  </div>
                </div>
              </div>

              <div
                type="button"
                button_name="roadmap"
                :data-toggle="!showPaths ? 'modal' : ''"
                data-target="#viz-1-modal"
                @click="handleStage('s-socialise')"
                class="stage-button dtm-button s-socialise"
                style="margin-top: 36.5px"
              >
                <div class="dia-bg" />

                <div class="dia-content">
                  <viz-1-icon-socialise width="23" height="19" :iconColor="iconColor" />

                  <div class="text-center">
                    <p class="text-body font-weight-bold mobile-diamond">Socialise</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="viz-1--user-inputs" v-if="!$breakpoint.desktop">
        <switch-com input-el-id="path-switch" label="Show connections" v-model="showPaths" />
      </div>
    </div>

    <!-- Modal -->
    <div :class="modalClass" id="viz-1-modal" tabindex="-1" role="dialog" aria-labelledby="viz-1-modal-label">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <button class="close-button" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>

          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12 modal-enabler" v-if="selectedEnabler">
                <p class="font-weight-bold text-body--large">{{ selectedEnabler.label }}</p>
                <p class="text-body">{{ selectedEnabler.desc }}</p>

                <div class="modal-enabler--company">
                  <p class="font-weight-bold text-body">Green FinTech companies:</p>

                  <div
                    class="company-grid"
                    :style="{ justifyContent: selectedEnabler.id === 'e-regtech' ? 'start' : 'space-between' }"
                  >
                    <div v-for="company in selectedEnabler.companies" :key="company">
                      <img
                        :src="`/assets/web-resources/techecosystem/fintech/2023/images/sff23-viz1-${company}.png`"
                        :alt="'Logo of ' + company"
                        :id="company"
                      />
                    </div>
                  </div>
                </div>

                <p class="font-weight-bold text-body">
                  {{ selectedEnabler.label }} enablers can help the following stages:
                </p>
                <ul>
                  <li v-for="stage in selectedEnabler.stages" :key="stage.id">
                    {{ stage.label }}
                  </li>
                </ul>
              </div>

              <div class="col-sm-12 modal-stage" v-if="selectedStage">
                <p class="font-weight-bold text-body--large">{{ selectedStage.type }}: {{ selectedStage.label }}</p>
                <p class="text-body">{{ selectedStage.desc }}</p>

                <p class="mt-30 font-weight-bold text-body">
                  Green FinTech enablers that can help with the {{ selectedStage.label }} stage:
                </p>
                <ul class="mb-0">
                  <li v-for="enablers in selectedStage.enablers" :key="enablers.id">
                    {{ enablers.label }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { select, json as fetchJson } from 'd3';
import SwitchCom from '@/components/ui/SwitchCom.vue';
import Viz1IconAssess from '@/components/icons/Viz1IconAssess.vue';
import Viz1IconDevelop from '@/components/icons/Viz1IconDevelop.vue';
import Viz1IconOperationalise from '@/components/icons/Viz1IconOperationalise.vue';
import Viz1IconSocialise from '@/components/icons/Viz1IconSocialise.vue';
import Viz1IconStrategise from '@/components/icons/Viz1IconStrategise.vue';

export default {
  name: 'VizStageEnablers',
  computed: {
    vizEnablersStages() {
      return this.content.sections ? this.content.sections.find((d) => d.id === 'viz-enablers-stages') : {};
    },
    copy() {
      return this.vizEnablersStages ? this.vizEnablersStages.content : { header: '' };
    },
    stageData() {
      return this.vizEnablersStages ? this.vizEnablersStages.data.stageData : [];
    },
    enablerData() {
      return this.vizEnablersStages ? this.vizEnablersStages.data.enablerData : [];
    },
  },
  components: {
    Viz1IconAssess,
    Viz1IconDevelop,
    Viz1IconOperationalise,
    Viz1IconSocialise,
    Viz1IconStrategise,
    SwitchCom,
  },
  watch: {
    showPaths() {
      this.handleReset();
    },
  },
  data() {
    return {
      modalClass: 'viz-1-modal modal fade',
      selectedEnabler: null,
      selectedStage: null,
      iconColor: '#ffffff',
      showPaths: false,
      content: {},
    };
  },
  mounted() {
    this.resizer();
  },
  async created() {
    window.addEventListener('resize', this.resizer);
    this.content = await fetchJson(`${process.env.BASE_URL}data/content/chapter-02.json`);
  },
  updated() {
    this.resizer();
  },
  destroyed() {
    window.removeEventListener('resize', this.resizer);
  },
  methods: {
    resizer() {
      const elements = Array.prototype.slice.call(document.querySelectorAll('.g-artboard'));
      const widthById = {};
      elements.forEach(function (el) {
        const parent = el.parentNode;
        const width = widthById[parent.id] || parent.getBoundingClientRect().width;
        const minwidth = el.getAttribute('data-min-width');
        const maxwidth = el.getAttribute('data-max-width');
        widthById[parent.id] = width;

        if (+minwidth <= width && (+maxwidth >= width || maxwidth === null)) {
          el.style.display = 'block';
        } else {
          el.style.display = 'none';
        }
      });
    },
    handleEnabler(selected) {
      this.selectedStage = null;
      this.selectedEnabler = this.enablerData.find((d) => d.id === selected);

      if (this.showPaths) {
        this.handleReset();
        this.handlePathEnabler(selected);
      }
    },
    handlePathEnabler(selected) {
      const selectedEnabler = this.enablerData.find((d) => d.id === selected);

      // make the rest gray
      select('.sff-2023-interactive-viz-1').selectAll('.stage-button').classed('inactive', true);
      select('.sff-2023-interactive-viz-1').selectAll('.enabler-button').classed('inactive', true);

      // make relevant stages highlight
      select('.sff-2023-interactive-viz-1').selectAll(`.enabler-button.${selected}`).classed('enabler-selected', true);
      selectedEnabler.stages.forEach((d) =>
        select('.sff-2023-interactive-viz-1').selectAll(`.${d.id}`).classed('active', true)
      );

      // make paths show e.g. line-{name of enabler}
      select('.sff-2023-interactive-viz-1').selectAll(`g.line.line-${selected}`).classed('enabler-selected', true);
      select('.sff-2023-interactive-viz-1').selectAll(`g.circle.circle-${selected}`).classed('enabler-selected', true);

      this.iconColor = '#121212';
    },
    handleStage(selected) {
      this.selectedEnabler = null;
      this.selectedStage = this.stageData.find((d) => d.id === selected);

      if (this.showPaths) {
        this.handleReset();
        this.handlePathStage(selected);
      }
    },
    handlePathStage(selected) {
      // make the rest grey
      select('.sff-2023-interactive-viz-1').selectAll('.stage-button').classed('inactive', true);
      select('.sff-2023-interactive-viz-1').selectAll('.enabler-button').classed('inactive', true);
      this.iconColor = '#121212';

      // make selection active to purple
      const selectedStage = this.stageData.find((d) => d.id === selected);
      selectedStage.enablers.forEach((d) =>
        select('.sff-2023-interactive-viz-1').selectAll(`.${d.id}`).classed('active', true)
      );
      select('.sff-2023-interactive-viz-1').selectAll(`.stage-button.${selected}`).classed('stage-selected', true);

      // make paths animate e.g. line-{name of stage}
      select('.sff-2023-interactive-viz-1').selectAll(`g.line.line-${selected}`).classed('stage-selected', true);
      select('.sff-2023-interactive-viz-1').selectAll(`g.circle.circle-${selected}`).classed('stage-selected', true);
    },
    handleReset() {
      // state of modal
      this.iconColor = '#ffffff';

      select('.sff-2023-interactive-viz-1').selectAll('.stage-button,g.line,g.circle').classed('stage-selected', false);
      select('.sff-2023-interactive-viz-1').selectAll('.stage-button').classed('inactive', false);
      select('.sff-2023-interactive-viz-1').selectAll('.stage-button').classed('active', false);

      select('.sff-2023-interactive-viz-1')
        .selectAll('.enabler-button,g.line,g.circle')
        .classed('enabler-selected', false);
      select('.sff-2023-interactive-viz-1').selectAll('.enabler-button').classed('inactive', false);
      select('.sff-2023-interactive-viz-1').selectAll('.enabler-button').classed('active', false);
    },
  },
};
</script>

<style scoped lang="scss">
.mb-15 {
  margin-bottom: 15px;
}

.mb-30 {
  margin-bottom: 30px;
}

h3.text-body--large {
  font-size: 20px;
  line-height: 1.35;
  font-weight: 700;
}

.sff-2023-interactive-viz-1 {
  overflow: hidden;

  #g-UOB-2023-box,
  #g-UOB-2023-box .g-artboard {
    margin: 0 auto;
  }
  #g-UOB-2023-box p {
    margin: 0;
  }
  #g-UOB-2023-box .g-aiAbs {
    position: absolute;
  }
  #g-UOB-2023-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
  }
  #g-UOB-2023-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-UOB-2023-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-UOB-2023-730px {
    position: relative;
    overflow: hidden;
  }
  #g-UOB-2023-730px .g-pstyle0 {
    font-weight: 700;
    line-height: 26px;
    font-size: 22px;
    color: rgb(0, 0, 0);
  }
  #g-UOB-2023-730px .g-pstyle1 {
    line-height: 18px;
    font-size: 15px;
    color: rgb(0, 0, 0);
  }
  #g-UOB-2023-730px .g-pstyle2 {
    line-height: 18px;
    font-size: 15px;
    text-align: center;
    color: rgb(0, 0, 0);
  }
  #g-UOB-2023-730px .g-pstyle3 {
    font-weight: 700;
    line-height: 19px;
    font-size: 16px;
    text-align: center;
  }
  #g-UOB-2023-730px .g-pstyle4 {
    text-align: center;
  }
  #g-UOB-2023-730px .g-pstyle5 {
    font-weight: 700;
    line-height: 19px;
    font-size: 16px;
    text-align: center;
    color: rgb(0, 94, 184);
  }
  #g-UOB-2023-730px .g-cstyle0 {
    font-weight: 500;
  }
  #g-UOB-2023-570px {
    position: relative;
    overflow: hidden;
  }
  #g-UOB-2023-570px .g-pstyle0 {
    font-weight: 700;
    line-height: 26px;
    font-size: 22px;
    color: rgb(0, 0, 0);
  }
  #g-UOB-2023-570px .g-pstyle1 {
    line-height: 18px;
    font-size: 15px;
    color: rgb(0, 0, 0);
  }
  #g-UOB-2023-570px .g-pstyle2 {
    line-height: 17px;
    font-size: 15px;
    text-align: center;
    color: rgb(0, 0, 0);
  }
  #g-UOB-2023-570px .g-pstyle3 {
    font-weight: 700;
    line-height: 17px;
    font-size: 15px;
    text-align: center;
  }
  #g-UOB-2023-570px .g-pstyle4 {
    text-align: center;
  }
  #g-UOB-2023-570px .g-pstyle5 {
    font-weight: 700;
    line-height: 17px;
    font-size: 15px;
    text-align: center;
    color: rgb(0, 94, 184);
  }
  #g-UOB-2023-395px {
    position: relative;
    overflow: hidden;
  }
  #g-UOB-2023-395px .g-pstyle0 {
    font-weight: 700;
    line-height: 24px;
    font-size: 20px;
  }
  #g-UOB-2023-395px .g-pstyle1 {
    text-align: center;
  }
  #g-UOB-2023-395px .g-pstyle2 {
    font-weight: 700;
    line-height: 15px;
    font-size: 13px;
    text-align: center;
    color: rgb(0, 94, 184);
  }
  #g-UOB-2023-395px .g-pstyle3 {
    font-weight: 700;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-UOB-2023-395px .g-pstyle4 {
    font-weight: 700;
    line-height: 16px;
    font-size: 13px;
    text-align: center;
    color: rgb(0, 94, 184);
  }
  #g-UOB-2023-320px {
    position: relative;
    overflow: hidden;
  }
  #g-UOB-2023-320px .g-pstyle0 {
    font-weight: 700;
    line-height: 24px;
    font-size: 20px;
  }
  #g-UOB-2023-320px .g-pstyle1 {
    text-align: center;
  }
  #g-UOB-2023-320px .g-pstyle2 {
    font-weight: 700;
    line-height: 15px;
    font-size: 12px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-UOB-2023-320px .g-pstyle3 {
    font-weight: 700;
    line-height: 15px;
    font-size: 13px;
    text-align: center;
    color: rgb(0, 94, 184);
  }
  #g-UOB-2023-320px .g-pstyle4 {
    font-weight: 700;
    line-height: 16px;
    font-size: 13px;
    text-align: center;
    color: rgb(0, 94, 184);
  }
}

// Stages buttons
.dia-bg {
  width: 175px;
  height: 175px;
  border-radius: 10px;
  background-color: #005eb8;
  transform: rotate(-45deg);
  transition: all 0.3s;
  border: 1px solid transparent;
  transition-timing-function: ease-in-out;
  transition-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
}

// Modal styles
.modal-dialog {
  height: 100% !important;
  margin: 0 auto !important;
  @media only screen and (max-width: #{map-get($grid-breakpoints, 'sm')}) {
    max-height: calc(100vh - 96px);
  }

  .modal-body {
    padding: 30px;
    width: 570px;
    @media only screen and (max-width: #{map-get($grid-breakpoints, 'sm')}) {
      width: 340px;
      padding: 30px 15px;
    }
  }

  .modal-nav {
    border: unset;
    display: flex;
    justify-content: start;
    margin-top: 40px;
    margin-bottom: 25px;
    position: relative;
    z-index: 5;
    padding: 0 25px;

    @media only screen and (max-width: 559px) {
      padding: 0 15px;
    }

    p {
      color: #005eb8;
      font-weight: 700;
      font-family: 'Noto Sans Bold', sans-serif;
    }
  }

  .modal-content {
    border-radius: 20px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-height: 85vh;
    overflow-y: scroll;
    width: 570px;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    &::-webkit-scrollbar {
      display: none;
    }

    @media only screen and (max-width: 559px) {
      width: 360px;
    }
  }

  .close-button {
    top: -5px;
    right: 15px;
    font-size: 4rem;
    position: absolute;
    z-index: 5;
    color: #005eb8;
  }
}
.modal-enabler {
  &--company {
    background: rgba(108, 217, 153, 0.2);
    padding: 20px;
    border-radius: 10px;
    margin: 15px 0;

    .company-grid {
      display: flex;
      flex-wrap: wrap;

      img {
        width: 135px;
        @media #{map-get($media-breakpoints, 'mobile')} {
          width: 85px;
        }
      }
    }
  }

  li {
    position: relative;
    list-style-type: none;
    padding-left: 35px;
  }

  li::before {
    content: '';
    background: #bfc9ff;
    transform: rotate(-45deg);
    position: absolute;
    width: 10px;
    height: 10px;
    left: 15px;
    top: 6px;
  }
}

.modal-stage {
  li {
    position: relative;
    list-style-type: none;
    padding-left: 35px;
  }

  li::before {
    content: '';
    background: #a1e6bd;
    position: absolute;
    width: 12px;
    height: 10px;
    left: 15px;
    top: 6px;
    border-radius: 2px;
  }
}

// Path style
g.line,
g.circle {
  visibility: hidden;
}

g.line.active,
g.circle.active {
  visibility: visible;
}

g.line.stage-selected,
g.circle.stage-selected {
  visibility: visible;
  path,
  polyline,
  line {
    stroke: #bfc9ff !important;
  }

  circle {
    fill: #bfc9ff !important;
  }
}

g.line.enabler-selected,
g.circle.enabler-selected {
  visibility: visible;
  path,
  polyline,
  line {
    stroke: #a1e6bd !important;
  }
}

// Legend icon
.rect-icon {
  display: inline-block;
  margin-left: 2.5px;
  border-radius: 2px;
  width: 17px;
  height: 15px;
  border: 1px solid #005eb8;
}

.dia-icon {
  display: inline-block;
  margin-left: 5px;
  width: 12px;
  height: 12px;
  position: relative;
  transform: rotate(-45deg);
  background: #005eb8;
  transition: all 0.2s;
}

// Styles for active and inactive states
.stage-button.inactive {
  .dia-bg {
    background-color: #f1f1f1;
  }
  p {
    color: #121212 !important;
  }
  path {
    fill: #121212;
  }
}

.enabler-button.inactive {
  border: 1px solid #a7a8a9;
  transition: all 0.2s;
  p {
    color: #a7a8a9 !important;
  }
}

.stage-button.stage-selected {
  transition: all 0.2s;
  .dia-bg {
    background-color: #bfc9ff;
    border: 1px solid #121212;
  }

  p {
    color: #121212 !important;
    transition: all 0.3s;
    transition-timing-function: ease-in-out;
    transition-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }

  path {
    fill: #121212;
    transition: all 0.2s;
    transition-timing-function: ease-in-out;
    transition-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
}

.stage-button.active {
  transition: all 0.2s;

  .dia-bg {
    background-color: #a1e6bd !important;
  }

  p {
    color: #121212 !important;
  }

  path {
    fill: #121212;
  }
}

// Styles for diamond and rounded rect buttons
.html-el {
  position: absolute;
  inset: 0;
  transition: all 0.2s;
  .legend {
    display: grid;
    grid-template-columns: 20px auto;
    align-items: baseline;
    column-gap: 10px;
  }

  .viz-1-enabler-buttons {
    border-radius: 25px;
    border: 1px dashed #a7a8a9;
    width: 33.3%;
    padding: 20px;
    margin-left: 5px;
    margin-right: 117px;
    height: max-content;

    .enabler-button {
      margin-bottom: 13px;
      padding: 15px 0;
      background-color: white;
      border: 1px solid #005eb8;
      border-radius: 8px;
      transition: all 0.25s;
    }

    .enabler-button:last-child {
      margin-bottom: 0;
    }

    .enabler-button.inactive {
      border: 1px solid #a7a8a9;
      p {
        color: #a7a8a9 !important;
      }
    }

    .enabler-button.active {
      background-color: #bfc9ff !important;
      border: 1px solid #bfc9ff !important;
      transition: all 0.3s;

      p {
        color: #121212 !important;
        transition: all 0.3s;
        transition-timing-function: ease-in-out;
        transition-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
      }
    }

    .enabler-button.enabler-selected {
      border: 1px solid #121212;
      background: #a1e6bd;
      p {
        color: #121212 !important;
      }
    }
  }

  .viz-1-stage-diamonds {
    padding-top: 38px;

    .stage-button {
      width: 175px;
      height: 175px;
      position: relative;
    }

    .dia-content {
      position: absolute;
      transform: translate(-50%, -50%);
      top: 45%;
      left: 50%;
      width: 100%;
      text-align: center;
      color: #ffffff !important;

      .text-body {
        margin-bottom: 8px;
        font-size: 18px;
      }

      svg {
        display: block;
        margin: 0 auto 15px;
      }
    }
  }
}

#g-UOB-2023-570px {
  .html-el {
    .legend {
      display: grid;
      grid-template-columns: 20px auto;
      align-items: baseline;
      column-gap: 10px;
    }

    .viz-1-enabler-buttons {
      margin-top: 7px;
      width: 32%;
      padding: 15px;
      margin-left: 0;
      margin-right: 60px;

      .enabler-button {
        margin-bottom: 16px;
        padding: 13.5px 0;
        p.text-body {
          font-size: 14px !important;
        }
      }
    }

    .viz-1-stage-diamonds {
      padding-top: 36px;

      .stage-button {
        width: 170px;
        height: 170px;
      }
      .dia-bg {
        width: 170px;
        height: 170px;
      }
      .dia-content {
        .text-body {
          margin-bottom: 8px;
          font-size: 15px !important;
        }

        .text-small {
          font-size: 14px !important;
        }

        svg {
          display: block;
          margin: 0 auto 15px;
        }
      }
    }
  }
}

#g-UOB-2023-395px {
  .rect-icon {
    width: 15px;
    height: 11px;
    vertical-align: baseline;
  }

  .dia-icon {
    width: 10px;
    height: 10px;
    vertical-align: baseline;
  }
  .html-el {
    .viz-1-header {
      margin-bottom: 25px;
      .legend {
        display: grid;
        grid-template-columns: 20px auto;
        align-items: baseline;
        column-gap: 5px;
      }
      p.text-body {
        font-size: 14px;
      }
    }

    .viz-1-enabler-buttons {
      margin-top: -6px;
      border-radius: 12px;
      width: 37.3%;
      padding: 8px 6px;
      margin-left: 0;
      margin-right: 58.5px;

      .enabler-button {
        margin-bottom: 9.5px;
        padding: 14px 0px;

        p.text-body {
          font-size: 14px !important;
        }
      }
    }

    .viz-1-stage-diamonds {
      padding-top: 50.5px;

      .dia-bg {
        width: 100px;
        height: 100px;
      }

      .stage-button {
        width: 100px;
        height: 100px;
      }

      .dia-content {
        .text-body {
          font-size: 13.5px;
        }
      }
    }
  }
}

#g-UOB-2023-320px {
  .rect-icon {
    width: 15px;
    height: 11px;
    vertical-align: baseline;
  }

  .dia-icon {
    width: 10px;
    height: 10px;
    vertical-align: baseline;
  }
  .html-el {
    .viz-1-header {
      margin-bottom: 25px;
      p.text-body {
        font-size: 14px;
      }

      .legend {
        display: grid;
        grid-template-columns: 20px auto;
        align-items: baseline;
        column-gap: 5px;
      }
    }

    .viz-1-enabler-buttons {
      margin-top: -6px;
      border-radius: 12px;
      width: 46.3%;
      padding: 8px;
      margin-left: 0;
      margin-right: 69.5px;

      .enabler-button {
        margin-bottom: 9.5px;
        padding: 13px 0px;
        border-radius: 10px;

        p.text-body {
          font-size: 14px !important;
        }
      }
    }

    .viz-1-stage-diamonds {
      padding-top: 2px;

      .dia-bg {
        width: 88px;
        height: 88px;
      }

      .stage-button {
        width: 88px;
        height: 88px;
      }

      .dia-content {
        top: 45%;

        svg {
          margin: 0 auto 8px;
        }

        .text-body {
          font-size: 12px;
          margin-bottom: 0;
        }
      }
    }
  }
}

.viz-1--user-inputs {
  position: absolute;
  top: 120px;
  right: 4px;
  display: flex;
  flex-direction: column;
  max-width: 200px;
  align-items: flex-end;
  gap: 5px;

  ::v-deep span.control-switch__label {
    margin-right: 0 !important;
  }
  ::v-deep div.switch {
    transform: scale(0.7) !important;
  }

  ::v-deep span.text-legend,
  button {
    font-size: 13.5px !important;
  }

  .reset-button {
    border-radius: 15px;
    border: 1px solid #005eb8;
    padding: 4px 12px;
    width: min-content;
  }

  @media only screen and (max-width: #{map-get($grid-breakpoints, 'sm')}) {
    align-items: flex-end;
  }

  @media only screen and (max-width: 424px) {
    bottom: 18%;
    top: unset;
    right: unset;
    left: 20px;
  }
}

.text--primary.enabler-label.text-body {
 color: #005EB8;
}

.text-body.mobile-diamond {
  font-size: 12px !important;
}
</style>